/**
 * Automatically Generated with Rails using {@link CompanySetting.template}
 * see {@link lib_development/generators/company_settings/company_settings_generator.rb} for details
 * run `rails g company_settings -f` to regenerate
 */

import * as React from 'react';

/**
 * All the possible company settings that can be used within the application
 */
export type CompanySettingsKeys =
  | 'accessible_date_and_phone'
  | 'add_cc_and_bcc_to_email'
  | 'additional_permissions'
  | 'additional_statuses'
  | 'advanced_reporting'
  | 'ai_criteria_score'
  | 'ai_custom_fields'
  | 'allow_bulk_pool'
  | 'allow_cover_letters'
  | 'allow_creating_company_teams'
  | 'allow_dei_fields_in_bulk_application_upload'
  | 'allow_editing_job_requisition_fields'
  | 'allow_inactive_structures'
  | 'allow_mydata_deletion'
  | 'allowed_email_suffixes_only_for_internal_jobs'
  | 'alternative_saml_claim_identifier'
  | 'always_send_notifications'
  | 'anonymous_screening'
  | 'api_logging'
  | 'api_redesign'
  | 'application_national_identifiers'
  | 'approval_lists'
  | 'approval_workflow_logging'
  | 'approval_workflows_additional_information'
  | 'auto_translate'
  | 'autofill_offer_fields_from_job_fields'
  | 'automatic_assignment_to_onboarding_improvements'
  | 'automatic_sftp_report_encryption'
  | 'automatically_reject_referrals'
  | 'basic_consent_management'
  | 'bulk_actions_open_stages'
  | 'bulk_csv_editing'
  | 'bulk_download'
  | 'bulk_email_job_seekers'
  | 'cached_job_and_stage_visibilities'
  | 'can_delete_scorecards'
  | 'can_skip_sign_off_stage'
  | 'candidate_assessment_workflow_automation_trigger'
  | 'candidate_copilot'
  | 'candidate_custom_fields'
  | 'candidate_details_in_offer_header'
  | 'candidate_job_preferences'
  | 'candidate_surveys'
  | 'careers_page_ai_auditor'
  | 'careers_site_builder_v2'
  | 'careers_site_chatbot'
  | 'careers_site_chatbot_voice_prompts'
  | 'careers_site_form_captchas'
  | 'chatbot_application_flow'
  | 'clientside_job_posting_filtering'
  | 'conditional_custom_fields'
  | 'create_cached_job_and_stage_visibilities'
  | 'create_requisitions_for_existing_jobs'
  | 'custom_field_option_labels'
  | 'custom_job_posting_locations'
  | 'customisable_columns'
  | 'cv_parsing'
  | 'cv_redaction'
  | 'dei_reports'
  | 'delay_essential_cookie_setting'
  | 'determine_interview_host'
  | 'disable_cookie_dialog'
  | 'disable_indeed_feed'
  | 'disable_public_hiring_profiles'
  | 'disable_referral_user_notifications'
  | 'disable_willUpdateUrl'
  | 'disallow_personal_referee_emails'
  | 'display_approval_status'
  | 'display_team_member_stages_in_onboarding_candidate_portal'
  | 'document_templates_multiple_signers'
  | 'docusign_logging'
  | 'download_pdf_application'
  | 'edit_offer_before_send'
  | 'edit_sent_offers'
  | 'edit_sent_offers_all_fields'
  | 'editable_question_answers'
  | 'email_link_tracking'
  | 'email_open_tracking'
  | 'email_template_table_view'
  | 'enable_cronofy_event_deletion_tracking'
  | 'enforce_all_offer_fields_required'
  | 'enforce_all_offer_salary_field'
  | 'essential_cookies_only'
  | 'experimental_parallel_report_generation'
  | 'experimental_report_filtering'
  | 'external_recruiters'
  | 'extra_monitoring_for_automations'
  | 'facebook_advert'
  | 'facebook_advert_exclude_instagram'
  | 'filled_tab'
  | 'filter_reports_by_candidate_current_stage'
  | 'generate_report_date_indexes'
  | 'google_analytics_enabled'
  | 'google_translate_widget'
  | 'group_assessments'
  | 'group_interviews'
  | 'grouped_jobs'
  | 'hide_cv_download'
  | 'hide_discarded_eq_templates_in_reports'
  | 'hide_individual_connect'
  | 'hybrid_interviews'
  | 'include_open_date_on_jobs_page'
  | 'indeed_disposition_sync'
  | 'indeed_feed_stages'
  | 'indeed_job_postings_api'
  | 'indeed_theme_sourcename'
  | 'indeed_use_shared_client_id'
  | 'inferred_answers'
  | 'insights_hub_global_filters'
  | 'instant_impact_client'
  | 'integer_ai_custom_fields'
  | 'integration_plugins'
  | 'internship_programme'
  | 'interview_invite_restriction'
  | 'job_posting_address'
  | 'job_requisition_management'
  | 'limit_onboarding_to_hired_candidates'
  | 'linkedin_job_postings'
  | 'linkedin_rsc'
  | 'location_city_state'
  | 'manage_communication_preferences'
  | 'manually_added_candidates_required_questions'
  | 'manually_send_offers'
  | 'marine_cv_parsing'
  | 'master_job_applications_view'
  | 'max_applications'
  | 'merge_attachments_to_pdf'
  | 'monitor_saml'
  | 'monitor_with_rum'
  | 'move_to_any_job'
  | 'move_to_hired_on_offer_acceptance'
  | 'multiple_company_themes'
  | 'multiple_job_postings'
  | 'multiple_question_collections'
  | 'multiple_video_interview_provider_support'
  | 'new_conferencing_provider_ux'
  | 'new_custom_field_reporting_filters'
  | 'new_workflow_automation_pricing'
  | 'no_reply_emails'
  | 'notify_interested_candidates'
  | 'offer_management'
  | 'offer_packs'
  | 'offer_retracted_notification'
  | 'offer_splitting'
  | 'onboarding_candidate_viewer_role'
  | 'onboarding_dashboard_stage_step_ownership'
  | 'onboarding_document_templates'
  | 'onboarding_notify_candidate_on_team_member_stage_completion'
  | 'onboarding_process_step_deadlock_handlers'
  | 'onboarding_v1'
  | 'onboarding_v2'
  | 'onboarding_v2_assigned_step_notifications'
  | 'onboarding_v2_background_check_need_review_opt_out'
  | 'onboarding_v2_enforce_job_visibilities'
  | 'onboarding_v2_notification_candidate_messages'
  | 'onboarding_v2_progress_tracker_updates'
  | 'onboarding_v2_reporting'
  | 'onboarding_v2_start_date_change_reasons'
  | 'onboarding_v2_turbocharger'
  | 'overriding_job_access'
  | 'personal_details_auto_update'
  | 'pinpoint_checks_paused'
  | 'position_management'
  | 'postmark_event_monitoring'
  | 'premium_workflow_automations'
  | 'private_calendar_events'
  | 'radius_search'
  | 'react_select_on_external_jobs'
  | 'recruitment_agencies'
  | 'recruitment_agency_location_matching'
  | 'redirect_moved_job_to_copied_object'
  | 'redirect_to_copied_object'
  | 'redirect_to_custom_subdomain'
  | 'reference_checking'
  | 'reference_checking_paused'
  | 'reference_checking_review_forms'
  | 'reference_checking_time_based'
  | 'referral_management'
  | 'referrals_user_notification_defaults'
  | 'refresh_csrf_token_before_application_submit'
  | 'reject_all_other_applications'
  | 'remove_comp_time_unit_on_offer'
  | 'remove_email_footer'
  | 'remove_logo_from_email_template'
  | 'report_empty_not_empty_operators'
  | 'report_only_csp'
  | 'require_headcount'
  | 'restrict_job_visibility'
  | 'restricted_cronofy_oauth_scope'
  | 'saved_views_open_stages'
  | 'scorecard_summary'
  | 'semi_private_comments'
  | 'send_daily_reminders_for_onboarding_stages'
  | 'send_pdf_copy_of_application'
  | 'send_rescheduled_interview_cancellation_events'
  | 'show_all_candidates_index'
  | 'show_api_keys_once'
  | 'show_compensation_by_default'
  | 'show_date_in_offer_header'
  | 'show_job_seekers_in_all_candidates'
  | 'show_pinpoint_credits_messaging'
  | 'sign_off_specificity_v2'
  | 'skills'
  | 'stage_dates_in_external_application'
  | 'stage_group_visibilities'
  | 'stage_visibilities'
  | 'state_filters'
  | 'strict_ofccp_compliance'
  | 'structured_sections'
  | 'talent_pipeline'
  | 'talent_pipeline_v2'
  | 'task_management'
  | 'team_rejection_notification'
  | 'updated_requisitions_cards'
  | 'upsell_reference_checking'
  | 'use_chunked_report_filtering'
  | 'use_company_from_address'
  | 'use_fallback_sign_off_workflows'
  | 'use_planetscale_optimized_candidate_queries'
  | 'use_report_date_indexes'
  | 'variable_sign_off_signatories'
  | 'video_interview_willo_paused'
  | 'visible_other_applications'
  | 'vonq_v2'
  | 'waypoint_logging'
  | 'whitelabelled_background_checks_msp'
  | 'whitelabelled_background_checks_msp_uat'
  | 'whitelabelled_certn_centric_background_checks'
  | 'willo_pinpoint_video_interviewing'
  | 'wism_cached_onboarding_application'
  | 'wism_metrics_tracking'
  | 'workflow_automation'
  | 'workflow_automation_v2'
  | 'youtube_cookie_management'
  | 'zinc_polling_process_onboarding_answers';

/**
 * The shape of our CompanySettings object, narrowed down to the available keys and values only.
 */
export interface ICompanySettings {
  /**
   * Additional application form accessibility
   */
  accessible_date_and_phone: boolean;
  /**
   * Add CC and BCC to Messages from Pinpoint
   */
  add_cc_and_bcc_to_email: boolean;
  /**
   * Additional permissions
   */
  additional_permissions: boolean;
  /**
   * Add hold and cancelled as additional statuses
   */
  additional_statuses: boolean;
  /**
   * Advanced Reporting
   */
  advanced_reporting: boolean;
  /**
   * AI criteria score
   */
  ai_criteria_score: boolean;
  /**
   * AI custom fields
   */
  ai_custom_fields: boolean;
  /**
   * Allow bulk pooling
   */
  allow_bulk_pool: boolean;
  /**
   * Allow requesting cover letters
   */
  allow_cover_letters: boolean;
  /**
   * Allow companies to create company teams
   */
  allow_creating_company_teams: boolean;
  /**
   * Allow DEI fields in bulk application upload
   */
  allow_dei_fields_in_bulk_application_upload: boolean;
  /**
   * Allow editing fields on a job that were set by the requisition
   */
  allow_editing_job_requisition_fields: boolean;
  /**
   * Allow for structures to be toggled as inactive
   */
  allow_inactive_structures: boolean;
  /**
   * Allow candidates to delete their own data
   */
  allow_mydata_deletion: boolean;
  /**
   * Validate email address on internal job applicants
   */
  allowed_email_suffixes_only_for_internal_jobs: boolean;
  /**
   * Alternative SAML claim identifier
   */
  alternative_saml_claim_identifier: boolean;
  /**
   * Always send user notifications
   */
  always_send_notifications: boolean;
  /**
   * Anonymous Screening
   */
  anonymous_screening: boolean;
  /**
   * API Logging
   */
  api_logging: boolean;
  /**
   * API Redesign
   */
  api_redesign: boolean;
  /**
   * Add national identifiers to applications and allow collecting it
   */
  application_national_identifiers: boolean;
  /**
   * Approval lists
   */
  approval_lists: boolean;
  /**
   * Approval workflow logging
   */
  approval_workflow_logging: boolean;
  /**
   * Approval workflows additional information
   */
  approval_workflows_additional_information: boolean;
  /**
   * Auto translate
   */
  auto_translate: boolean;
  /**
   * Autofill Offer Fields from Job Fields
   */
  autofill_offer_fields_from_job_fields: boolean;
  /**
   * Automatic assignment to onboarding
   */
  automatic_assignment_to_onboarding_improvements: boolean;
  /**
   * Automatic SFTP report encryption
   */
  automatic_sftp_report_encryption: boolean;
  /**
   * Automatically reject a referral when the application is rejected
   */
  automatically_reject_referrals: boolean;
  /**
   * Basic consent management
   */
  basic_consent_management: boolean;
  /**
   * Bulk actions on open stages
   */
  bulk_actions_open_stages: boolean;
  /**
   * Bulk CSV editing
   */
  bulk_csv_editing: boolean;
  /**
   * Allow bulk download of applications in CSV format from the table actions
   */
  bulk_download: boolean;
  /**
   * Allow bulk emailing job seekers
   */
  bulk_email_job_seekers: boolean;
  /**
   * Cached job visibilities
   */
  cached_job_and_stage_visibilities: boolean;
  /**
   * Can delete scorecards
   */
  can_delete_scorecards: boolean;
  /**
   * Can skip sign-off stage
   */
  can_skip_sign_off_stage: boolean;
  /**
   * Allow candidate assessment workflow automation trigger
   */
  candidate_assessment_workflow_automation_trigger: boolean;
  /**
   * AI Hiring Copilot
   */
  candidate_copilot: boolean;
  /**
   * Candidate custom fields
   */
  candidate_custom_fields: boolean;
  /**
   * Show the candidate name and address in the header on the offer letters
   */
  candidate_details_in_offer_header: boolean;
  /**
   * Candidate job preferences
   */
  candidate_job_preferences: boolean;
  /**
   * Candidate surveys
   */
  candidate_surveys: boolean;
  /**
   * Careers page AI auditor
   */
  careers_page_ai_auditor: boolean;
  /**
   * Careers Site Builder V2
   */
  careers_site_builder_v2: boolean;
  /**
   * Careers site chatbot
   */
  careers_site_chatbot: boolean;
  /**
   * Chatbot voice prompting
   */
  careers_site_chatbot_voice_prompts: boolean;
  /**
   * Use CAPTCHAs in Careers Site forms
   */
  careers_site_form_captchas: boolean;
  /**
   * Chatbot application flow
   */
  chatbot_application_flow: boolean;
  /**
   * Client-side job posting filtering
   */
  clientside_job_posting_filtering: boolean;
  /**
   * Conditional custom fields
   */
  conditional_custom_fields: boolean;
  /**
   * Create cached job visibilities
   */
  create_cached_job_and_stage_visibilities: boolean;
  /**
   * Enable creating requisitions for existing job
   */
  create_requisitions_for_existing_jobs: boolean;
  /**
   * Enable custom field option labels
   */
  custom_field_option_labels: boolean;
  /**
   * Allow custom job posting locations
   */
  custom_job_posting_locations: boolean;
  /**
   * Customisable columns
   */
  customisable_columns: boolean;
  /**
   * CV Parsing
   */
  cv_parsing: boolean;
  /**
   * CV Redaction
   */
  cv_redaction: boolean;
  /**
   * Allow creating DEI reports
   */
  dei_reports: boolean;
  /**
   * Delay essential cookie setting
   */
  delay_essential_cookie_setting: boolean;
  /**
   * Determine Interview Host
   */
  determine_interview_host: boolean;
  /**
   * Disable all Pinpoint cookie dialogs
   */
  disable_cookie_dialog: boolean;
  /**
   * Disable the indeed feed for this company
   */
  disable_indeed_feed: boolean;
  /**
   * Disable public hiring profiles
   */
  disable_public_hiring_profiles: boolean;
  /**
   * Disable Referral User New Job Notifications
   */
  disable_referral_user_notifications: boolean;
  /**
   * Disable willUpdateUrl
   */
  disable_willUpdateUrl: boolean;
  /**
   * Disallow personal referee emails
   */
  disallow_personal_referee_emails: boolean;
  /**
   * Display approval status in offers table
   */
  display_approval_status: boolean;
  /**
   * Display Team Member stages in Onboarding Candidate Portal
   */
  display_team_member_stages_in_onboarding_candidate_portal: boolean;
  /**
   * Document templates multiple signers
   */
  document_templates_multiple_signers: boolean;
  /**
   * Extra monitoring for docusign envelopes
   */
  docusign_logging: boolean;
  /**
   * Allow downloading applications as a PDF
   */
  download_pdf_application: boolean;
  /**
   * Editable offer letter at time of creation
   */
  edit_offer_before_send: boolean;
  /**
   * Can modify sent offer date fields and resend the offer
   */
  edit_sent_offers: boolean;
  /**
   * Can edit sent offers
   */
  edit_sent_offers_all_fields: boolean;
  /**
   * Editable question answers
   */
  editable_question_answers: boolean;
  /**
   * Enable email link tracking
   */
  email_link_tracking: boolean;
  /**
   * Enable email open tracking
   */
  email_open_tracking: boolean;
  /**
   * Email Template Table View
   */
  email_template_table_view: boolean;
  /**
   * Event deletion notifications
   */
  enable_cronofy_event_deletion_tracking: boolean;
  /**
   * Require completion of all offer fields
   */
  enforce_all_offer_fields_required: boolean;
  /**
   * Enforce offer salary fields
   */
  enforce_all_offer_salary_field: boolean;
  /**
   * Enable essential cookies only
   */
  essential_cookies_only: boolean;
  /**
   * Enable experimental parallel report generation
   */
  experimental_parallel_report_generation: boolean;
  /**
   * Experimental report filtering
   */
  experimental_report_filtering: boolean;
  /**
   * External Recruiters
   */
  external_recruiters: boolean;
  /**
   * Extra monitoring for automations
   */
  extra_monitoring_for_automations: boolean;
  /**
   * Facebook advert creation
   */
  facebook_advert: boolean;
  /**
   * Facebook Advert Exclude Instagram
   */
  facebook_advert_exclude_instagram: boolean;
  /**
   * Filled tab
   */
  filled_tab: boolean;
  /**
   * Filter Reports by Candidate Current Stage
   */
  filter_reports_by_candidate_current_stage: boolean;
  /**
   * Generate report date indexes
   */
  generate_report_date_indexes: boolean;
  /**
   * Google Analytics enabled
   */
  google_analytics_enabled: boolean;
  /**
   * Google Translate Widget
   */
  google_translate_widget: boolean;
  /**
   * Group assessments
   */
  group_assessments: boolean;
  /**
   * Enable group interviews
   */
  group_interviews: boolean;
  /**
   * Allow grouping jobs
   */
  grouped_jobs: boolean;
  /**
   * Hide CV download
   */
  hide_cv_download: boolean;
  /**
   * Report on discarded equality monitoring templates
   */
  hide_discarded_eq_templates_in_reports: boolean;
  /**
   * Hide individual connect
   */
  hide_individual_connect: boolean;
  /**
   * Hybrid interviews
   */
  hybrid_interviews: boolean;
  /**
   * Include open date on jobs page
   */
  include_open_date_on_jobs_page: boolean;
  /**
   * Send Disposition Data to Indeed
   */
  indeed_disposition_sync: boolean;
  /**
   * Add the external stages to the indeed feed job description
   */
  indeed_feed_stages: boolean;
  /**
   * Post Jobs to Indeed via API
   */
  indeed_job_postings_api: boolean;
  /**
   * Indeed theme sourcename
   */
  indeed_theme_sourcename: boolean;
  /**
   * Enable Indeed Apply (using shared/partner client id)
   */
  indeed_use_shared_client_id: boolean;
  /**
   * Inferred Answers
   */
  inferred_answers: boolean;
  /**
   * Insights hub global filters
   */
  insights_hub_global_filters: boolean;
  /**
   * Instant Impact client
   */
  instant_impact_client: boolean;
  /**
   * Integer AI custom fields
   */
  integer_ai_custom_fields: boolean;
  /**
   * Integration plugins
   */
  integration_plugins: boolean;
  /**
   * Change the platform for 10,000 interns programme
   */
  internship_programme: boolean;
  /**
   * Interview invite restriction
   */
  interview_invite_restriction: boolean;
  /**
   * Job posting address
   */
  job_posting_address: boolean;
  /**
   * Enable job requisition management
   */
  job_requisition_management: boolean;
  /**
   * Limit sending applicants to onboarding to only those in hired
   */
  limit_onboarding_to_hired_candidates: boolean;
  /**
   * LinkedIn job postings
   */
  linkedin_job_postings: boolean;
  /**
   * LinkedIn Recruiter System Connect
   */
  linkedin_rsc: boolean;
  /**
   * Use city, state as the location name externally
   */
  location_city_state: boolean;
  /**
   * Basic communication preference management
   */
  manage_communication_preferences: boolean;
  /**
   * Manually Added Candidates - Required Questions
   */
  manually_added_candidates_required_questions: boolean;
  /**
   * Allow approved offers to be edited before sending to candidates
   */
  manually_send_offers: boolean;
  /**
   * Marine CV parsing
   */
  marine_cv_parsing: boolean;
  /**
   * Master job applications view
   */
  master_job_applications_view: boolean;
  /**
   * Limit the number of applications per candidate
   */
  max_applications: boolean;
  /**
   * Merge All Attachments Into Single PDF Export
   */
  merge_attachments_to_pdf: boolean;
  /**
   * Monitor SAML logins and attempts
   */
  monitor_saml: boolean;
  /**
   * Monitor logged in users with realtime user monitoring
   */
  monitor_with_rum: boolean;
  /**
   * Allow moving an application to any job
   */
  move_to_any_job: boolean;
  /**
   * Move applications to hired once an offer is accepted
   */
  move_to_hired_on_offer_acceptance: boolean;
  /**
   * Enable the ability to create and manage multiple themes for this company
   */
  multiple_company_themes: boolean;
  /**
   * Allow creating multiple job postings per job
   */
  multiple_job_postings: boolean;
  /**
   * Multiple question collections
   */
  multiple_question_collections: boolean;
  /**
   * Multiple Video Interview Provider Support
   */
  multiple_video_interview_provider_support: boolean;
  /**
   * New conferencing provider UX
   */
  new_conferencing_provider_ux: boolean;
  /**
   * Custom field reporting filters
   */
  new_custom_field_reporting_filters: boolean;
  /**
   * Automations Pricing V2
   */
  new_workflow_automation_pricing: boolean;
  /**
   * No reply emails
   */
  no_reply_emails: boolean;
  /**
   * Notify interested candidates
   */
  notify_interested_candidates: boolean;
  /**
   * Offer Management
   */
  offer_management: boolean;
  /**
   * Offer packs
   */
  offer_packs: boolean;
  /**
   * Send offer retraction notification
   */
  offer_retracted_notification: boolean;
  /**
   * Offer splitting
   */
  offer_splitting: boolean;
  /**
   * Onboarding Candidate Viewer Role
   */
  onboarding_candidate_viewer_role: boolean;
  /**
   * Onboarding Dashboard and stage / step ownership
   */
  onboarding_dashboard_stage_step_ownership: boolean;
  /**
   * Onboarding document templates
   */
  onboarding_document_templates: boolean;
  /**
   * Onboarding notify candidate on team member stage completion
   */
  onboarding_notify_candidate_on_team_member_stage_completion: boolean;
  /**
   * Onboarding process step deadlock handlers
   */
  onboarding_process_step_deadlock_handlers: boolean;
  /**
   * Onboarding V1
   */
  onboarding_v1: boolean;
  /**
   * Onboarding V2
   */
  onboarding_v2: boolean;
  /**
   * Onboarding V2 assigned step notifications
   */
  onboarding_v2_assigned_step_notifications: boolean;
  /**
   * Onboarding V2 background check need review opt-out
   */
  onboarding_v2_background_check_need_review_opt_out: boolean;
  /**
   * Onboarding V2 enforce job visibilities
   */
  onboarding_v2_enforce_job_visibilities: boolean;
  /**
   * Onboarding V2 notification candidate messages
   */
  onboarding_v2_notification_candidate_messages: boolean;
  /**
   * Onboarding V2 progress tracker updates
   */
  onboarding_v2_progress_tracker_updates: boolean;
  /**
   * Onboarding V2 reporting
   */
  onboarding_v2_reporting: boolean;
  /**
   * Onboarding V2 start date change reasons
   */
  onboarding_v2_start_date_change_reasons: boolean;
  /**
   * Onboarding V2 performance enhancements
   */
  onboarding_v2_turbocharger: boolean;
  /**
   * Overriding Job Access
   */
  overriding_job_access: boolean;
  /**
   * Personal details auto update
   */
  personal_details_auto_update: boolean;
  /**
   * Pinpoint Background Checks (powered by Certn)
   */
  pinpoint_checks_paused: boolean;
  /**
   * Position Management
   */
  position_management: boolean;
  /**
   * Postmark event monitoring
   */
  postmark_event_monitoring: boolean;
  /**
   * Advanced Automations
   */
  premium_workflow_automations: boolean;
  /**
   * Add calendar events as private
   */
  private_calendar_events: boolean;
  /**
   * Radius search
   */
  radius_search: boolean;
  /**
   * Use the react select on the external job index pages. Added for accessibility purposes should not be toggled on
   */
  react_select_on_external_jobs: boolean;
  /**
   * Recruitment Agencies
   */
  recruitment_agencies: boolean;
  /**
   * Recruitment Agency Location Matching
   */
  recruitment_agency_location_matching: boolean;
  /**
   * Redirect job to copied object
   */
  redirect_moved_job_to_copied_object: boolean;
  /**
   * Redirect to copied object
   */
  redirect_to_copied_object: boolean;
  /**
   * Redirect all careers site requests to custom subdomain
   */
  redirect_to_custom_subdomain: boolean;
  /**
   * Reference checking
   */
  reference_checking: boolean;
  /**
   * Reference checking
   */
  reference_checking_paused: boolean;
  /**
   * Reference checking review forms
   */
  reference_checking_review_forms: boolean;
  /**
   * Dynamic Reference Checking
   */
  reference_checking_time_based: boolean;
  /**
   * Referral Management
   */
  referral_management: boolean;
  /**
   * Referral user notification defaults
   */
  referrals_user_notification_defaults: boolean;
  /**
   * Refresh CSRF Token Before Application Submit
   */
  refresh_csrf_token_before_application_submit: boolean;
  /**
   * Reject all other applications
   */
  reject_all_other_applications: boolean;
  /**
   * Remove compensation time unit on offer
   */
  remove_comp_time_unit_on_offer: boolean;
  /**
   * Remove email footer
   */
  remove_email_footer: boolean;
  /**
   * Remove the company logo from the email template
   */
  remove_logo_from_email_template: boolean;
  /**
   * Report empty / not empty operators
   */
  report_empty_not_empty_operators: boolean;
  /**
   * Switch CSP policy to report only for company careers site
   */
  report_only_csp: boolean;
  /**
   * Require headcount on job creation
   */
  require_headcount: boolean;
  /**
   * Restrict job visibility
   */
  restrict_job_visibility: boolean;
  /**
   * Limit the Cronofy scope to just read free busy. Please do not turn this on without confirming with the engineering team
   */
  restricted_cronofy_oauth_scope: boolean;
  /**
   * Saved Views Open Stages
   */
  saved_views_open_stages: boolean;
  /**
   * Scorecard Summary
   */
  scorecard_summary: boolean;
  /**
   * Allow company managers to view private comments
   */
  semi_private_comments: boolean;
  /**
   * Send daily reminders for onboarding stages
   */
  send_daily_reminders_for_onboarding_stages: boolean;
  /**
   * Allow candidates to receive a pdf copy of their details when applying
   */
  send_pdf_copy_of_application: boolean;
  /**
   * Send Rescheduled Interview Cancellation Events
   */
  send_rescheduled_interview_cancellation_events: boolean;
  /**
   * Master all candidates view
   */
  show_all_candidates_index: boolean;
  /**
   * Show API keys once
   */
  show_api_keys_once: boolean;
  /**
   * Show compensation by default
   */
  show_compensation_by_default: boolean;
  /**
   * Show the date in the header on the offer letters
   */
  show_date_in_offer_header: boolean;
  /**
   * Show job seekers in the all candidates view
   */
  show_job_seekers_in_all_candidates: boolean;
  /**
   * Show Pinpoint Credits Messaging
   */
  show_pinpoint_credits_messaging: boolean;
  /**
   * Sign-off specificity V2
   */
  sign_off_specificity_v2: boolean;
  /**
   * Allow managing and filtering on skills
   */
  skills: boolean;
  /**
   * Stage group movement dates into the API
   */
  stage_dates_in_external_application: boolean;
  /**
   * Stage group visibilities
   */
  stage_group_visibilities: boolean;
  /**
   * Can assign visibilities to stages
   */
  stage_visibilities: boolean;
  /**
   * State filters
   */
  state_filters: boolean;
  /**
   * Restrict any action that does not comply with OFCCP
   */
  strict_ofccp_compliance: boolean;
  /**
   * Structured sections
   */
  structured_sections: boolean;
  /**
   * Enable the talent pipeline
   */
  talent_pipeline: boolean;
  /**
   * Talent Pipeline V2
   */
  talent_pipeline_v2: boolean;
  /**
   * Task Management
   */
  task_management: boolean;
  /**
   * Send sign off rejection notifications to anyone with visibility
   */
  team_rejection_notification: boolean;
  /**
   * Updated requisitions cards
   */
  updated_requisitions_cards: boolean;
  /**
   * Upsell Reference Checking
   */
  upsell_reference_checking: boolean;
  /**
   * Use chunked report filtering for large datasets
   */
  use_chunked_report_filtering: boolean;
  /**
   * Use company@pinpoint.email instead of uuid@pinpoint.email when sending emails
   */
  use_company_from_address: boolean;
  /**
   * Use fallback workflows when approvable resources have no matching sign-off workflows
   */
  use_fallback_sign_off_workflows: boolean;
  /**
   * PlanetScale optimized candidate queries
   */
  use_planetscale_optimized_candidate_queries: boolean;
  /**
   * Use report date indexes
   */
  use_report_date_indexes: boolean;
  /**
   * Approval workflows v2
   */
  variable_sign_off_signatories: boolean;
  /**
   * Video Interviews (powered by Willo)
   */
  video_interview_willo_paused: boolean;
  /**
   * Show other applications regardless of visibilities
   */
  visible_other_applications: boolean;
  /**
   * Use the Vonq V2 API
   */
  vonq_v2: boolean;
  /**
   * Waypoint logging
   */
  waypoint_logging: boolean;
  /**
   * Whitelabelled Background Checks MSP
   */
  whitelabelled_background_checks_msp: boolean;
  /**
   * Whitelabelled Background Checks MSP UAT
   */
  whitelabelled_background_checks_msp_uat: boolean;
  /**
   * Whitelabelled Certn-Centric Background Checks
   */
  whitelabelled_certn_centric_background_checks: boolean;
  /**
   * Pinpoint Video Interviewing (powered by Willo)
   */
  willo_pinpoint_video_interviewing: boolean;
  /**
   * Wism cached onboarding application
   */
  wism_cached_onboarding_application: boolean;
  /**
   * Wism metrics tracking
   */
  wism_metrics_tracking: boolean;
  /**
   * Job Automations
   */
  workflow_automation: boolean;
  /**
   * Basic Automations
   */
  workflow_automation_v2: boolean;
  /**
   * YouTube cookie management
   */
  youtube_cookie_management: boolean;
  /**
   * Use polling to Zinc result endpoint to process onboarding answers
   */
  zinc_polling_process_onboarding_answers: boolean;
}

export interface IAccessibleDateAndPhoneTemplate {
  default_value: false;
  description: "If toggled on, phone and date fields will use simple html elements and we add an asterisk to required questions";
  name: 'Additional application form accessibility';
  link: '';
  setting_key: 'accessible_date_and_phone';
  values: [true, false];
}
export interface IAddCcAndBccToEmailTemplate {
  default_value: false;
  description: "If toggled on, certain messages sent from within Pinpoint will allow CC and BCC addresses to be added.";
  name: 'Add CC and BCC to Messages from Pinpoint';
  link: '';
  setting_key: 'add_cc_and_bcc_to_email';
  values: [true, false];
}
export interface IAdditionalPermissionsTemplate {
  default_value: false;
  description: "If toggled on, we will allow (and enforce) the use of additional permissions for users";
  name: 'Additional permissions';
  link: '';
  setting_key: 'additional_permissions';
  values: [true, false];
}
export interface IAdditionalStatusesTemplate {
  default_value: false;
  description: "";
  name: 'Add hold and cancelled as additional statuses';
  link: '';
  setting_key: 'additional_statuses';
  values: [true, false];
}
export interface IAdvancedReportingTemplate {
  default_value: false;
  description: "If toggled on, clients will have access to the Insights Hub and Report Builder";
  name: 'Advanced Reporting';
  link: '';
  setting_key: 'advanced_reporting';
  values: [true, false];
}
export interface IAiCriteriaScoreTemplate {
  default_value: true;
  description: "If toggled on, users can give candidates a score using multiple AI criteria to evaluate suitability.";
  name: 'AI criteria score';
  link: '';
  setting_key: 'ai_criteria_score';
  values: [true, false];
}
export interface IAiCustomFieldsTemplate {
  default_value: true;
  description: "If toggled on, we will allow users to create custom fields that use AI to generate content";
  name: 'AI custom fields';
  link: 'https://pinpoint.fibery.io/Databases/Projects/AI-Powered-Custom-Fields-227';
  setting_key: 'ai_custom_fields';
  values: [true, false];
}
export interface IAllowBulkPoolTemplate {
  default_value: false;
  description: "If toggled on, users will be able to bulk pool candidates. This is only shown when 10,000 interns programme setting is toggled on.";
  name: 'Allow bulk pooling';
  link: '';
  setting_key: 'allow_bulk_pool';
  values: [true, false];
}
export interface IAllowCoverLettersTemplate {
  default_value: false;
  description: "If toggled on, you can request a cover letter on the application form";
  name: 'Allow requesting cover letters';
  link: '';
  setting_key: 'allow_cover_letters';
  values: [true, false];
}
export interface IAllowCreatingCompanyTeamsTemplate {
  default_value: false;
  description: "If toggled on, companies will be able to create teams that exist outside of the normal visibilities restrictions.";
  name: 'Allow companies to create company teams';
  link: '';
  setting_key: 'allow_creating_company_teams';
  values: [true, false];
}
export interface IAllowDeiFieldsInBulkApplicationUploadTemplate {
  default_value: false;
  description: "If toggled on, users will be able to include DEI fields when uploading applications in bulk via CSV.";
  name: 'Allow DEI fields in bulk application upload';
  link: '';
  setting_key: 'allow_dei_fields_in_bulk_application_upload';
  values: [true, false];
}
export interface IAllowEditingJobRequisitionFieldsTemplate {
  default_value: false;
  description: "";
  name: 'Allow editing fields on a job that were set by the requisition';
  link: '';
  setting_key: 'allow_editing_job_requisition_fields';
  values: [true, false];
}
export interface IAllowInactiveStructuresTemplate {
  default_value: false;
  description: "";
  name: 'Allow for structures to be toggled as inactive';
  link: '';
  setting_key: 'allow_inactive_structures';
  values: [true, false];
}
export interface IAllowMydataDeletionTemplate {
  default_value: true;
  description: "If toggled on, we will allow candidates to delete their personal information using the Manage My Data tool";
  name: 'Allow candidates to delete their own data';
  link: '';
  setting_key: 'allow_mydata_deletion';
  values: [true, false];
}
export interface IAllowedEmailSuffixesOnlyForInternalJobsTemplate {
  default_value: false;
  description: "If toggled on, candidates applying to internal jobs using the external application form will have to supply an email address from an allowed internal email domain";
  name: 'Validate email address on internal job applicants';
  link: '';
  setting_key: 'allowed_email_suffixes_only_for_internal_jobs';
  values: [true, false];
}
export interface IAlternativeSamlClaimIdentifierTemplate {
  default_value: false;
  description: "If toggled on, we will allow the use of an alternative SAML claim identifier for logging into the platform";
  name: 'Alternative SAML claim identifier';
  link: '';
  setting_key: 'alternative_saml_claim_identifier';
  values: [true, false];
}
export interface IAlwaysSendNotificationsTemplate {
  default_value: false;
  description: "If toggled on, we will always send user notifications even if the user has not logged into the platform before";
  name: 'Always send user notifications';
  link: '';
  setting_key: 'always_send_notifications';
  values: [true, false];
}
export interface IAnonymousScreeningTemplate {
  default_value: true;
  description: "If toggled on, clients will be able to turn anonymous screening on for jobs";
  name: 'Anonymous Screening';
  link: '';
  setting_key: 'anonymous_screening';
  values: [true, false];
}
export interface IApiLoggingTemplate {
  default_value: true;
  description: "If toggled on, we will log API requests for this company. Logs are retained for 30 days.";
  name: 'API Logging';
  link: '';
  setting_key: 'api_logging';
  values: [true, false];
}
export interface IApiRedesignTemplate {
  default_value: true;
  description: "If toggled on, we will enable the redesigned API management for this company.";
  name: 'API Redesign';
  link: '';
  setting_key: 'api_redesign';
  values: [true, false];
}
export interface IApplicationNationalIdentifiersTemplate {
  default_value: false;
  description: "";
  name: 'Add national identifiers to applications and allow collecting it';
  link: '';
  setting_key: 'application_national_identifiers';
  values: [true, false];
}
export interface IApprovalListsTemplate {
  default_value: false;
  description: "If toggled on, users will be able to create approval lists for sign-off workflows";
  name: 'Approval lists';
  link: '';
  setting_key: 'approval_lists';
  values: [true, false];
}
export interface IApprovalWorkflowLoggingTemplate {
  default_value: false;
  description: "If toggled on, we will log each time the an approval is requested";
  name: 'Approval workflow logging';
  link: '';
  setting_key: 'approval_workflow_logging';
  values: [true, false];
}
export interface IApprovalWorkflowsAdditionalInformationTemplate {
  default_value: false;
  description: "If toggled on, users will be able to see additional information as signatories on approval workflows";
  name: 'Approval workflows additional information';
  link: '';
  setting_key: 'approval_workflows_additional_information';
  values: [true, false];
}
export interface IAutoTranslateTemplate {
  default_value: false;
  description: "If toggled on, we will automatically use AI to translate user generated content. This currently only works for questions";
  name: 'Auto translate';
  link: '';
  setting_key: 'auto_translate';
  values: [true, false];
}
export interface IAutofillOfferFieldsFromJobFieldsTemplate {
  default_value: false;
  description: "If toggled on, we will automatically fill in offer fields from the job fields when creating a new offer";
  name: 'Autofill Offer Fields from Job Fields';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Auto-populate-offer-data-from-job-225';
  setting_key: 'autofill_offer_fields_from_job_fields';
  values: [true, false];
}
export interface IAutomaticAssignmentToOnboardingImprovementsTemplate {
  default_value: true;
  description: "If toggled on, users will be able to automatically assign candidates to a default onboarding process using jobs and workflow automations";
  name: 'Automatic assignment to onboarding';
  link: '';
  setting_key: 'automatic_assignment_to_onboarding_improvements';
  values: [true, false];
}
export interface IAutomaticSftpReportEncryptionTemplate {
  default_value: false;
  description: "If toggled on, all reports sent via SFTP will be automatically encrypted using the company's PGP public key";
  name: 'Automatic SFTP report encryption';
  link: '';
  setting_key: 'automatic_sftp_report_encryption';
  values: [true, false];
}
export interface IAutomaticallyRejectReferralsTemplate {
  default_value: false;
  description: "";
  name: 'Automatically reject a referral when the application is rejected';
  link: '';
  setting_key: 'automatically_reject_referrals';
  values: [true, false];
}
export interface IBasicConsentManagementTemplate {
  default_value: false;
  description: "If toggled on, applicants will have the option of allowing data to be used for one job or all jobs";
  name: 'Basic consent management';
  link: '';
  setting_key: 'basic_consent_management';
  values: [true, false];
}
export interface IBulkActionsOpenStagesTemplate {
  default_value: true;
  description: "If toggled on, users will be able to perform bulk actions on candidates in the open stage view";
  name: 'Bulk actions on open stages';
  link: '';
  setting_key: 'bulk_actions_open_stages';
  values: [true, false];
}
export interface IBulkCsvEditingTemplate {
  default_value: false;
  description: "If toggled on, users will be able to bulk edit jobs and positions using a CSV upload";
  name: 'Bulk CSV editing';
  link: '';
  setting_key: 'bulk_csv_editing';
  values: [true, false];
}
export interface IBulkDownloadTemplate {
  default_value: false;
  description: "";
  name: 'Allow bulk download of applications in CSV format from the table actions';
  link: '';
  setting_key: 'bulk_download';
  values: [true, false];
}
export interface IBulkEmailJobSeekersTemplate {
  default_value: false;
  description: "This was only created for the 10kbi project and should not be enabled for anyone";
  name: 'Allow bulk emailing job seekers';
  link: '';
  setting_key: 'bulk_email_job_seekers';
  values: [true, false];
}
export interface ICachedJobAndStageVisibilitiesTemplate {
  default_value: false;
  description: "If toggled on, we will use cached job visibilities for all job visibility checks. You MUST have Create cached job visibilities toggled on for this to work";
  name: 'Cached job visibilities';
  link: '';
  setting_key: 'cached_job_and_stage_visibilities';
  values: [true, false];
}
export interface ICanDeleteScorecardsTemplate {
  default_value: false;
  description: "If toggled on, users with the company manager role will be able to delete scorecards";
  name: 'Can delete scorecards';
  link: '';
  setting_key: 'can_delete_scorecards';
  values: [true, false];
}
export interface ICanSkipSignOffStageTemplate {
  default_value: false;
  description: "If toggled on, users will be able to skip the next sign-off stage instead of defining the next stages approvers";
  name: 'Can skip sign-off stage';
  link: '';
  setting_key: 'can_skip_sign_off_stage';
  values: [true, false];
}
export interface ICandidateAssessmentWorkflowAutomationTriggerTemplate {
  default_value: false;
  description: "If toggled on, users will have access the ability to trigger workflow automations based on candidate assessment status changes";
  name: 'Allow candidate assessment workflow automation trigger';
  link: 'https://pinpoint.fibery.io/search/fTtz8#Resourcing/Allocations/Assessment-Completion-Based-Stage-WFA-74';
  setting_key: 'candidate_assessment_workflow_automation_trigger';
  values: [true, false];
}
export interface ICandidateCopilotTemplate {
  default_value: false;
  description: "If toggled on, users will have access to the AI-powered hiring copilot feature.";
  name: 'AI Hiring Copilot';
  link: '';
  setting_key: 'candidate_copilot';
  values: [true, false];
}
export interface ICandidateCustomFieldsTemplate {
  default_value: false;
  description: "If toggled on, users will be able to create custom fields for candidates";
  name: 'Candidate custom fields';
  link: '';
  setting_key: 'candidate_custom_fields';
  values: [true, false];
}
export interface ICandidateDetailsInOfferHeaderTemplate {
  default_value: false;
  description: "If toggled on, we will show the candidate name and address in the header on the offer letters";
  name: 'Show the candidate name and address in the header on the offer letters';
  link: '';
  setting_key: 'candidate_details_in_offer_header';
  values: [true, false];
}
export interface ICandidateJobPreferencesTemplate {
  default_value: false;
  description: "Allow applicants to choose a 2nd and 3rd job preference when applying";
  name: 'Candidate job preferences';
  link: '';
  setting_key: 'candidate_job_preferences';
  values: [true, false];
}
export interface ICandidateSurveysTemplate {
  default_value: true;
  description: "If toggled on, clients will be able to send candidate surveys";
  name: 'Candidate surveys';
  link: '';
  setting_key: 'candidate_surveys';
  values: [true, false];
}
export interface ICareersPageAiAuditorTemplate {
  default_value: false;
  description: "If toggled on, users will be able to use AI to audit the careers page for recommendations on how to improve content";
  name: 'Careers page AI auditor';
  link: '';
  setting_key: 'careers_page_ai_auditor';
  values: [true, false];
}
export interface ICareersSiteBuilderV2Template {
  default_value: false;
  description: "This feature is under active development and should NOT be turned on";
  name: 'Careers Site Builder V2';
  link: '';
  setting_key: 'careers_site_builder_v2';
  values: [true, false];
}
export interface ICareersSiteChatbotTemplate {
  default_value: false;
  description: "If toggled on, we will show a chatbot on the careers site to help candidates find jobs and answer questions";
  name: 'Careers site chatbot';
  link: '';
  setting_key: 'careers_site_chatbot';
  values: [true, false];
}
export interface ICareersSiteChatbotVoicePromptsTemplate {
  default_value: false;
  description: "If toggled on, we will allow users to use voice prompting in the careers site chatbot";
  name: 'Chatbot voice prompting';
  link: '';
  setting_key: 'careers_site_chatbot_voice_prompts';
  values: [true, false];
}
export interface ICareersSiteFormCaptchasTemplate {
  default_value: false;
  description: "If toggled on, candidates applying to jobs will need to confirm that they are not a robot. NOTE - This does not currently work with custom domains.";
  name: 'Use CAPTCHAs in Careers Site forms';
  link: '';
  setting_key: 'careers_site_form_captchas';
  values: [true, false];
}
export interface IChatbotApplicationFlowTemplate {
  default_value: false;
  description: "If toggled on, candidates will be able to use the chatbot to complete an application";
  name: 'Chatbot application flow';
  link: '';
  setting_key: 'chatbot_application_flow';
  values: [true, false];
}
export interface IClientsideJobPostingFilteringTemplate {
  default_value: false;
  description: "If toggled on, job postings on the careers site will be filtered on the client side once fetched from the server. This is a stop-gap measure in cases where Fastly incorrectly caches a postings.json endpoint";
  name: 'Client-side job posting filtering';
  link: '';
  setting_key: 'clientside_job_posting_filtering';
  values: [true, false];
}
export interface IConditionalCustomFieldsTemplate {
  default_value: true;
  description: "If toggled on, users will be able to create conditional and visibility scoped custom fields";
  name: 'Conditional custom fields';
  link: '';
  setting_key: 'conditional_custom_fields';
  values: [true, false];
}
export interface ICreateCachedJobAndStageVisibilitiesTemplate {
  default_value: false;
  description: "If toggled on, we will create job visibilities for this company in a separate table";
  name: 'Create cached job visibilities';
  link: '';
  setting_key: 'create_cached_job_and_stage_visibilities';
  values: [true, false];
}
export interface ICreateRequisitionsForExistingJobsTemplate {
  default_value: true;
  description: "If toggled on, users will be able to create a requisition for an existing role to increase heacount";
  name: 'Enable creating requisitions for existing job';
  link: '';
  setting_key: 'create_requisitions_for_existing_jobs';
  values: [true, false];
}
export interface ICustomFieldOptionLabelsTemplate {
  default_value: false;
  description: "If toggled on, we will allow users to set the labels and values for their custom field options";
  name: 'Enable custom field option labels';
  link: '';
  setting_key: 'custom_field_option_labels';
  values: [true, false];
}
export interface ICustomJobPostingLocationsTemplate {
  default_value: false;
  description: "If toggled on, users will be able to add custom locations to job postings, these job postings are outside of the normal company structure";
  name: 'Allow custom job posting locations';
  link: '';
  setting_key: 'custom_job_posting_locations';
  values: [true, false];
}
export interface ICustomisableColumnsTemplate {
  default_value: true;
  description: "If toggled on, users will be able to customise the columns shown on the job application index pages";
  name: 'Customisable columns';
  link: '';
  setting_key: 'customisable_columns';
  values: [true, false];
}
export interface ICvParsingTemplate {
  default_value: true;
  description: "If toggled on, we will automatically parse candidate CVs via Affinda to extract information and add skills.";
  name: 'CV Parsing';
  link: '';
  setting_key: 'cv_parsing';
  values: [true, false];
}
export interface ICvRedactionTemplate {
  default_value: true;
  description: "If toggled on, we will automatically redact personally identifiable information from candidate CVs when anonymous screening is enabled for a role.";
  name: 'CV Redaction';
  link: '';
  setting_key: 'cv_redaction';
  values: [true, false];
}
export interface IDeiReportsTemplate {
  default_value: false;
  description: "If toggled on, users can create a report that shows the equality monitoring stats without personal information";
  name: 'Allow creating DEI reports';
  link: '';
  setting_key: 'dei_reports';
  values: [true, false];
}
export interface IDelayEssentialCookieSettingTemplate {
  default_value: false;
  description: "If toggled on, we will delay the setting of essential cookies until the user gets to the application form.";
  name: 'Delay essential cookie setting';
  link: '';
  setting_key: 'delay_essential_cookie_setting';
  values: [true, false];
}
export interface IDetermineInterviewHostTemplate {
  default_value: false;
  description: "If toggled on, we will make the interview host mandatory";
  name: 'Determine Interview Host';
  link: 'https://pinpoint.fibery.io/search/1N9Uh#Databases/Projects/Determine-interview-host-for-non-conferencing-interviews-242';
  setting_key: 'determine_interview_host';
  values: [true, false];
}
export interface IDisableCookieDialogTemplate {
  default_value: false;
  description: "If toggled on we will not show any cookie dialogs to the user. Do not enable this setting unless the customer has supplied their own cookie management solution.";
  name: 'Disable all Pinpoint cookie dialogs';
  link: '';
  setting_key: 'disable_cookie_dialog';
  values: [true, false];
}
export interface IDisableIndeedFeedTemplate {
  default_value: false;
  description: "We will return an empty feed for the company when you visit the indeed feed path";
  name: 'Disable the indeed feed for this company';
  link: '';
  setting_key: 'disable_indeed_feed';
  values: [true, false];
}
export interface IDisablePublicHiringProfilesTemplate {
  default_value: false;
  description: "If toggled on, we will disable the public hiring profiles feature. Public profiles will not be shown on the careers site";
  name: 'Disable public hiring profiles';
  link: '';
  setting_key: 'disable_public_hiring_profiles';
  values: [true, false];
}
export interface IDisableReferralUserNotificationsTemplate {
  default_value: false;
  description: "If toggled on, referral users will never receive notifications when new referral jobs are posted.";
  name: 'Disable Referral User New Job Notifications';
  link: '';
  setting_key: 'disable_referral_user_notifications';
  values: [true, false];
}
export interface IDisableWillupdateurlTemplate {
  default_value: false;
  description: "If toggled on, we will set willUpdateUrl to false in the Search component on careers sites, fixing the back button issue.";
  name: 'Disable willUpdateUrl';
  link: '';
  setting_key: 'disable_willUpdateUrl';
  values: [true, false];
}
export interface IDisallowPersonalRefereeEmailsTemplate {
  default_value: false;
  description: "If toggled on, we will not allow users to add personal email addresses to referees for reference checking.";
  name: 'Disallow personal referee emails';
  link: '';
  setting_key: 'disallow_personal_referee_emails';
  values: [true, false];
}
export interface IDisplayApprovalStatusTemplate {
  default_value: true;
  description: "If toggled on the offers table will display whether an approval is waiting internal approval.";
  name: 'Display approval status in offers table';
  link: '';
  setting_key: 'display_approval_status';
  values: [true, false];
}
export interface IDisplayTeamMemberStagesInOnboardingCandidatePortalTemplate {
  default_value: false;
  description: "Allows users to optionally show team-member-facing steps to the candidate in their onboarding portal";
  name: 'Display Team Member stages in Onboarding Candidate Portal';
  link: '';
  setting_key: 'display_team_member_stages_in_onboarding_candidate_portal';
  values: [true, false];
}
export interface IDocumentTemplatesMultipleSignersTemplate {
  default_value: false;
  description: "If toggled on, we will allow users to create document templates that require multiple signers";
  name: 'Document templates multiple signers';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Multiple-signers-on-document-templates-169';
  setting_key: 'document_templates_multiple_signers';
  values: [true, false];
}
export interface IDocusignLoggingTemplate {
  default_value: false;
  description: "If toggled on, we will add extra monitoring for docusign envelopes, used for debugging purposes";
  name: 'Extra monitoring for docusign envelopes';
  link: '';
  setting_key: 'docusign_logging';
  values: [true, false];
}
export interface IDownloadPdfApplicationTemplate {
  default_value: false;
  description: "If toggled on, users will be able to download applications as a PDF";
  name: 'Allow downloading applications as a PDF';
  link: '';
  setting_key: 'download_pdf_application';
  values: [true, false];
}
export interface IEditOfferBeforeSendTemplate {
  default_value: true;
  description: "Allows editing of the offer letter from its template before it is created and sent";
  name: 'Editable offer letter at time of creation';
  link: '';
  setting_key: 'edit_offer_before_send';
  values: [true, false];
}
export interface IEditSentOffersTemplate {
  default_value: false;
  description: "If toggled on, you will be able to update start date and expiry date on sent offers and re-send, they will not re-trigger sign-off workflows";
  name: 'Can modify sent offer date fields and resend the offer';
  link: '';
  setting_key: 'edit_sent_offers';
  values: [true, false];
}
export interface IEditSentOffersAllFieldsTemplate {
  default_value: false;
  description: "If toggled on, you will be able to edit all fields on sent offers (without re-sending the offer or re-triggering sign-off workflows)";
  name: 'Can edit sent offers';
  link: '';
  setting_key: 'edit_sent_offers_all_fields';
  values: [true, false];
}
export interface IEditableQuestionAnswersTemplate {
  default_value: false;
  description: "If toggled on, we will allow users to edit candidate question answers";
  name: 'Editable question answers';
  link: '';
  setting_key: 'editable_question_answers';
  values: [true, false];
}
export interface IEmailLinkTrackingTemplate {
  default_value: true;
  description: "Track when recipients click links in emails sent from Pinpoint";
  name: 'Enable email link tracking';
  link: '';
  setting_key: 'email_link_tracking';
  values: [true, false];
}
export interface IEmailOpenTrackingTemplate {
  default_value: true;
  description: "If toggled off, we will not track when recipients open emails sent from Pinpoint. Disble this if the client is having issues with the tracking.";
  name: 'Enable email open tracking';
  link: '';
  setting_key: 'email_open_tracking';
  values: [true, false];
}
export interface IEmailTemplateTableViewTemplate {
  default_value: false;
  description: "Display email templates in a table view (under development).";
  name: 'Email Template Table View';
  link: '';
  setting_key: 'email_template_table_view';
  values: [true, false];
}
export interface IEnableCronofyEventDeletionTrackingTemplate {
  default_value: false;
  description: "If toggled on, we will notify users when events are deleted from calendars";
  name: 'Event deletion notifications';
  link: '';
  setting_key: 'enable_cronofy_event_deletion_tracking';
  values: [true, false];
}
export interface IEnforceAllOfferFieldsRequiredTemplate {
  default_value: false;
  description: "If toggled on, when you create or update an offer all fields will be required for it to be valid";
  name: 'Require completion of all offer fields';
  link: '';
  setting_key: 'enforce_all_offer_fields_required';
  values: [true, false];
}
export interface IEnforceAllOfferSalaryFieldTemplate {
  default_value: false;
  description: "If toggled on, when you create or update an offer all salary fields will be required for it to be valid";
  name: 'Enforce offer salary fields';
  link: '';
  setting_key: 'enforce_all_offer_salary_field';
  values: [true, false];
}
export interface IEssentialCookiesOnlyTemplate {
  default_value: false;
  description: "If toggled on, we will only set essential cookies. The cookies set will be 'session-only' which means they will be deleted automatically when you close your browser (or the tab, depending on the browser’s session handling). The ahoy cookies will not be set at all which means we will not track visits or page views.";
  name: 'Enable essential cookies only';
  link: '';
  setting_key: 'essential_cookies_only';
  values: [true, false];
}
export interface IExperimentalParallelReportGenerationTemplate {
  default_value: false;
  description: "Uses a new experimental worker to generate reports in parallel, which may be faster for large reports. Please don't enable this unless you're sure you know what you're doing.";
  name: 'Enable experimental parallel report generation';
  link: '';
  setting_key: 'experimental_parallel_report_generation';
  values: [true, false];
}
export interface IExperimentalReportFilteringTemplate {
  default_value: false;
  description: "If toggled on, we will use a new experimental filtering system for reports that is designed to improve performance and allow for more complex filters. This is an experimental feature and may cause issues with some reports.";
  name: 'Experimental report filtering';
  link: '';
  setting_key: 'experimental_report_filtering';
  values: [true, false];
}
export interface IExternalRecruitersTemplate {
  default_value: true;
  description: "If toggled on, users will be able to manage external recruiters within the platform.";
  name: 'External Recruiters';
  link: '';
  setting_key: 'external_recruiters';
  values: [true, false];
}
export interface IExtraMonitoringForAutomationsTemplate {
  default_value: false;
  description: "If toggled on, we will log all of the automation enqueuing for this company";
  name: 'Extra monitoring for automations';
  link: '';
  setting_key: 'extra_monitoring_for_automations';
  values: [true, false];
}
export interface IFacebookAdvertTemplate {
  default_value: false;
  description: "This is something that only a handful of old clients use. We do not promote it, and it will be sunset at some point";
  name: 'Facebook advert creation';
  link: '';
  setting_key: 'facebook_advert';
  values: [true, false];
}
export interface IFacebookAdvertExcludeInstagramTemplate {
  default_value: false;
  description: "If toggled on, Facebook adverts will be set to exclude Instagram placements by default.";
  name: 'Facebook Advert Exclude Instagram';
  link: '';
  setting_key: 'facebook_advert_exclude_instagram';
  values: [true, false];
}
export interface IFilledTabTemplate {
  default_value: false;
  description: "If toggled on, users will have a seperate filled tab on the job index page";
  name: 'Filled tab';
  link: '';
  setting_key: 'filled_tab';
  values: [true, false];
}
export interface IFilterReportsByCandidateCurrentStageTemplate {
  default_value: true;
  description: "Allows users to filter candidate and assessment reports by the candidate's current stage in the hiring process.";
  name: 'Filter Reports by Candidate Current Stage';
  link: '';
  setting_key: 'filter_reports_by_candidate_current_stage';
  values: [true, false];
}
export interface IGenerateReportDateIndexesTemplate {
  default_value: false;
  description: "When enabled, creates DateIndex records for application date fields (hired_at, rejected_at, start_on) to optimize report filtering. Enable this first before enabling 'Use report date indexes'.";
  name: 'Generate report date indexes';
  link: '';
  setting_key: 'generate_report_date_indexes';
  values: [true, false];
}
export interface IGoogleAnalyticsEnabledTemplate {
  default_value: false;
  description: "If toggled on, we will add Google Analytics cookie descriptions to the cookie banner. This only needs to be enabled if users are using Google Analytics on your careers site.";
  name: 'Google Analytics enabled';
  link: '';
  setting_key: 'google_analytics_enabled';
  values: [true, false];
}
export interface IGoogleTranslateWidgetTemplate {
  default_value: false;
  description: "If toggled on, we will allow users to use the Google Translate widget in the onboarding portal";
  name: 'Google Translate Widget';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Translate-Onboarding-Portal-248';
  setting_key: 'google_translate_widget';
  values: [true, false];
}
export interface IGroupAssessmentsTemplate {
  default_value: false;
  description: "Allows users to create group assessments for candidates";
  name: 'Group assessments';
  link: '';
  setting_key: 'group_assessments';
  values: [true, false];
}
export interface IGroupInterviewsTemplate {
  default_value: false;
  description: "Currently under construction do not enable";
  name: 'Enable group interviews';
  link: '';
  setting_key: 'group_interviews';
  values: [true, false];
}
export interface IGroupedJobsTemplate {
  default_value: false;
  description: "";
  name: 'Allow grouping jobs';
  link: '';
  setting_key: 'grouped_jobs';
  values: [true, false];
}
export interface IHideCvDownloadTemplate {
  default_value: false;
  description: "If toggled on, we will hide the CV download button on the application and candidate pages";
  name: 'Hide CV download';
  link: '';
  setting_key: 'hide_cv_download';
  values: [true, false];
}
export interface IHideDiscardedEqTemplatesInReportsTemplate {
  default_value: true;
  description: "If toggled on, equality monitoring reports will exclude records associated with discarded equality monitoring templates";
  name: 'Report on discarded equality monitoring templates';
  link: '';
  setting_key: 'hide_discarded_eq_templates_in_reports';
  values: [true, false];
}
export interface IHideIndividualConnectTemplate {
  default_value: false;
  description: "If toggled on, we will hide the individual connect button from individual users, this will only apply to companies that have an enterprise connect token set up";
  name: 'Hide individual connect';
  link: '';
  setting_key: 'hide_individual_connect';
  values: [true, false];
}
export interface IHybridInterviewsTemplate {
  default_value: true;
  description: "If toggled on, we allow conference links for in-person interviews";
  name: 'Hybrid interviews';
  link: '';
  setting_key: 'hybrid_interviews';
  values: [true, false];
}
export interface IIncludeOpenDateOnJobsPageTemplate {
  default_value: false;
  description: "If toggled on, we will show the open date and application deadline on the jobs page";
  name: 'Include open date on jobs page';
  link: '';
  setting_key: 'include_open_date_on_jobs_page';
  values: [true, false];
}
export interface IIndeedDispositionSyncTemplate {
  default_value: true;
  description: "Pinpoint will notify Indeed about candidate application state changes when this switch is enabled. Only applies to applications that came from Indeed Apply.";
  name: 'Send Disposition Data to Indeed';
  link: '';
  setting_key: 'indeed_disposition_sync';
  values: [true, false];
}
export interface IIndeedFeedStagesTemplate {
  default_value: false;
  description: "";
  name: 'Add the external stages to the indeed feed job description';
  link: '';
  setting_key: 'indeed_feed_stages';
  values: [true, false];
}
export interface IIndeedJobPostingsApiTemplate {
  default_value: false;
  description: "Pinpoint will send job postings to Indeed via API when this switch is enabled.";
  name: 'Post Jobs to Indeed via API';
  link: '';
  setting_key: 'indeed_job_postings_api';
  values: [true, false];
}
export interface IIndeedThemeSourcenameTemplate {
  default_value: false;
  description: "If toggled on, we will use the theme name as the sourcename for the indeed feed. Only applies to companies with multiple themes";
  name: 'Indeed theme sourcename';
  link: '';
  setting_key: 'indeed_theme_sourcename';
  values: [true, false];
}
export interface IIndeedUseSharedClientIdTemplate {
  default_value: true;
  description: "If toggled on, we enable Indeed Apply for all job postings in the XML feed. As Indeed Platinum Partner we should keep this enabled this for vast majority of companies, so please disable as the last resort.";
  name: 'Enable Indeed Apply (using shared/partner client id)';
  link: 'https://app.getguru.com/card/TgAjpkyc/Indeed-Job-Posting-Apply';
  setting_key: 'indeed_use_shared_client_id';
  values: [true, false];
}
export interface IInferredAnswersTemplate {
  default_value: false;
  description: "If toggled on, Pinpoint will use AI to infer answers to question collections based on the candidate CVs.";
  name: 'Inferred Answers';
  link: '';
  setting_key: 'inferred_answers';
  values: [true, false];
}
export interface IInsightsHubGlobalFiltersTemplate {
  default_value: true;
  description: "If toggled on, will expose global filters in the insights hub";
  name: 'Insights hub global filters';
  link: 'https://pinpoint.fibery.io/search/MS4R9#Databases/Projects/Dashboard-level-filter-on-Insights-Hub-221';
  setting_key: 'insights_hub_global_filters';
  values: [true, false];
}
export interface IInstantImpactClientTemplate {
  default_value: false;
  description: "If toggled on, clients will be able to request that instant impact source for their jobs";
  name: 'Instant Impact client';
  link: '';
  setting_key: 'instant_impact_client';
  values: [true, false];
}
export interface IIntegerAiCustomFieldsTemplate {
  default_value: true;
  description: "If toggled on, we will allow users to create custom fields that use AI to generate integer and number values";
  name: 'Integer AI custom fields';
  link: '';
  setting_key: 'integer_ai_custom_fields';
  values: [true, false];
}
export interface IIntegrationPluginsTemplate {
  default_value: false;
  description: "If toggled on, integration plugin features will be enabled. This feature is still under development and testing.";
  name: 'Integration plugins';
  link: '';
  setting_key: 'integration_plugins';
  values: [true, false];
}
export interface IInternshipProgrammeTemplate {
  default_value: false;
  description: "If toggled on, the platform is changed for the 10,000 interns programme";
  name: 'Change the platform for 10,000 interns programme';
  link: '';
  setting_key: 'internship_programme';
  values: [true, false];
}
export interface IInterviewInviteRestrictionTemplate {
  default_value: false;
  description: "If toggled on, we will restrict interview invites to only applications that are at an interview stage";
  name: 'Interview invite restriction';
  link: '';
  setting_key: 'interview_invite_restriction';
  values: [true, false];
}
export interface IJobPostingAddressTemplate {
  default_value: false;
  description: "If toggled on, we will show the job posting address on the job page";
  name: 'Job posting address';
  link: '';
  setting_key: 'job_posting_address';
  values: [true, false];
}
export interface IJobRequisitionManagementTemplate {
  default_value: false;
  description: "";
  name: 'Enable job requisition management';
  link: '';
  setting_key: 'job_requisition_management';
  values: [true, false];
}
export interface ILimitOnboardingToHiredCandidatesTemplate {
  default_value: false;
  description: "If toggled on, you will only be able to invite applicants to onboarding when they are in the hired stage";
  name: 'Limit sending applicants to onboarding to only those in hired';
  link: '';
  setting_key: 'limit_onboarding_to_hired_candidates';
  values: [true, false];
}
export interface ILinkedinJobPostingsTemplate {
  default_value: false;
  description: "If toggled on, users will be able to post jobs to LinkedIn via the job posting API";
  name: 'LinkedIn job postings';
  link: '';
  setting_key: 'linkedin_job_postings';
  values: [true, false];
}
export interface ILinkedinRscTemplate {
  default_value: true;
  description: "If toggled on, users will be able to use LinkedIn RSC";
  name: 'LinkedIn Recruiter System Connect';
  link: '';
  setting_key: 'linkedin_rsc';
  values: [true, false];
}
export interface ILocationCityStateTemplate {
  default_value: false;
  description: "If toggled on, we display the location name as city, state instead of the location name defined";
  name: 'Use city, state as the location name externally';
  link: '';
  setting_key: 'location_city_state';
  values: [true, false];
}
export interface IManageCommunicationPreferencesTemplate {
  default_value: true;
  description: "If toggled on, candidates will be able to manage their basic communication preferences";
  name: 'Basic communication preference management';
  link: '';
  setting_key: 'manage_communication_preferences';
  values: [true, false];
}
export interface IManuallyAddedCandidatesRequiredQuestionsTemplate {
  default_value: false;
  description: "Enforce required application questions when manually adding candidates. If disabled, candidates can be added even if required questions are left blank.";
  name: 'Manually Added Candidates - Required Questions';
  link: '';
  setting_key: 'manually_added_candidates_required_questions';
  values: [true, false];
}
export interface IManuallySendOffersTemplate {
  default_value: false;
  description: "If toggled on, offers will not be automatically sent to candidates. They can be edited before being manually sent to the candidate";
  name: 'Allow approved offers to be edited before sending to candidates';
  link: '';
  setting_key: 'manually_send_offers';
  values: [true, false];
}
export interface IMarineCvParsingTemplate {
  default_value: false;
  description: "If toggled on, we will ask for a specific Marine CV on the application form and use a specialised parser for marine CVs";
  name: 'Marine CV parsing';
  link: '';
  setting_key: 'marine_cv_parsing';
  values: [true, false];
}
export interface IMasterJobApplicationsViewTemplate {
  default_value: false;
  description: "If toggled on, users will be able to view all company job applications, with a new link on the primary nav";
  name: 'Master job applications view';
  link: '';
  setting_key: 'master_job_applications_view';
  values: [true, false];
}
export interface IMaxApplicationsTemplate {
  default_value: false;
  description: "If toggled on, ensure that a number of applications allowed limit has been set in the company preferences on the admin side";
  name: 'Limit the number of applications per candidate';
  link: 'https://app.getguru.com/card/i7jjzM9T';
  setting_key: 'max_applications';
  values: [true, false];
}
export interface IMergeAttachmentsToPdfTemplate {
  default_value: false;
  description: "If toggled on, application PDF exports will convert and merge all attachments (images, DOCX, PDFs) into a single PDF file instead of creating a ZIP archive.";
  name: 'Merge All Attachments Into Single PDF Export';
  link: '';
  setting_key: 'merge_attachments_to_pdf';
  values: [true, false];
}
export interface IMonitorSamlTemplate {
  default_value: false;
  description: "";
  name: 'Monitor SAML logins and attempts';
  link: '';
  setting_key: 'monitor_saml';
  values: [true, false];
}
export interface IMonitorWithRumTemplate {
  default_value: false;
  description: "";
  name: 'Monitor logged in users with realtime user monitoring';
  link: '';
  setting_key: 'monitor_with_rum';
  values: [true, false];
}
export interface IMoveToAnyJobTemplate {
  default_value: false;
  description: "";
  name: 'Allow moving an application to any job';
  link: '';
  setting_key: 'move_to_any_job';
  values: [true, false];
}
export interface IMoveToHiredOnOfferAcceptanceTemplate {
  default_value: true;
  description: "Clients may want to turn this off if they have stages between offer and hired";
  name: 'Move applications to hired once an offer is accepted';
  link: '';
  setting_key: 'move_to_hired_on_offer_acceptance';
  values: [true, false];
}
export interface IMultipleCompanyThemesTemplate {
  default_value: false;
  description: "";
  name: 'Enable the ability to create and manage multiple themes for this company';
  link: '';
  setting_key: 'multiple_company_themes';
  values: [true, false];
}
export interface IMultipleJobPostingsTemplate {
  default_value: false;
  description: "";
  name: 'Allow creating multiple job postings per job';
  link: '';
  setting_key: 'multiple_job_postings';
  values: [true, false];
}
export interface IMultipleQuestionCollectionsTemplate {
  default_value: false;
  description: "If toggled on, users will be able to add multiple question collections to a single request additional information request";
  name: 'Multiple question collections';
  link: '';
  setting_key: 'multiple_question_collections';
  values: [true, false];
}
export interface IMultipleVideoInterviewProviderSupportTemplate {
  default_value: false;
  description: "If toggled on, users will have access the ability to use multiple video interview providers and control which is used at a given time";
  name: 'Multiple Video Interview Provider Support';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Willo-Pinpoint-Video-Interviewing-142';
  setting_key: 'multiple_video_interview_provider_support';
  values: [true, false];
}
export interface INewConferencingProviderUxTemplate {
  default_value: false;
  description: "If toggled on, we will show the new conferencing provider UX in the interview invite form";
  name: 'New conferencing provider UX';
  link: '';
  setting_key: 'new_conferencing_provider_ux';
  values: [true, false];
}
export interface INewCustomFieldReportingFiltersTemplate {
  default_value: true;
  description: "If toggled on, we will show the custom field reporting filters in reports";
  name: 'Custom field reporting filters';
  link: '';
  setting_key: 'new_custom_field_reporting_filters';
  values: [true, false];
}
export interface INewWorkflowAutomationPricingTemplate {
  default_value: true;
  description: "If toggled on, companies will follow the new pricing model for automations. Only those on the legacy basic automations plan should have this turned off.";
  name: 'Automations Pricing V2';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Adjust-WFA-pricing-logic-236';
  setting_key: 'new_workflow_automation_pricing';
  values: [true, false];
}
export interface INoReplyEmailsTemplate {
  default_value: false;
  description: "If toggled this will allow emails to be sent from a no-reply email address (Under Development).";
  name: 'No reply emails';
  link: '';
  setting_key: 'no_reply_emails';
  values: [true, false];
}
export interface INotifyInterestedCandidatesTemplate {
  default_value: false;
  description: "If toggled on, users will have access the ability to automatically notify interested talent pipeline candidates when creating or updating a job using workflow automations";
  name: 'Notify interested candidates';
  link: '';
  setting_key: 'notify_interested_candidates';
  values: [true, false];
}
export interface IOfferManagementTemplate {
  default_value: true;
  description: "If toggled on, clients will be able to manage offers within the platform";
  name: 'Offer Management';
  link: '';
  setting_key: 'offer_management';
  values: [true, false];
}
export interface IOfferPacksTemplate {
  default_value: false;
  description: "If toggled on, users can create and manage offer packs instead of offer templates";
  name: 'Offer packs';
  link: '';
  setting_key: 'offer_packs';
  values: [true, false];
}
export interface IOfferRetractedNotificationTemplate {
  default_value: false;
  description: "If toggled on, we will send a notification to the candidate when an offer is retracted";
  name: 'Send offer retraction notification';
  link: '';
  setting_key: 'offer_retracted_notification';
  values: [true, false];
}
export interface IOfferSplittingTemplate {
  default_value: false;
  description: "If toggled on, users will be able to create offers but not complete the email or letter until the original offer is approved";
  name: 'Offer splitting';
  link: '';
  setting_key: 'offer_splitting';
  values: [true, false];
}
export interface IOnboardingCandidateViewerRoleTemplate {
  default_value: false;
  description: "If toggled on, the onboarding candidate viewer role will be available for assignment to users";
  name: 'Onboarding Candidate Viewer Role';
  link: '';
  setting_key: 'onboarding_candidate_viewer_role';
  values: [true, false];
}
export interface IOnboardingDashboardStageStepOwnershipTemplate {
  default_value: true;
  description: "This is default on and should be removed as a company setting. Left because of the carnage in the tests when removed";
  name: 'Onboarding Dashboard and stage / step ownership';
  link: '';
  setting_key: 'onboarding_dashboard_stage_step_ownership';
  values: [true, false];
}
export interface IOnboardingDocumentTemplatesTemplate {
  default_value: true;
  description: "If toggled on, we will show the document template step type in onboarding. Also includes the change to the document and esignature question type in onboarding";
  name: 'Onboarding document templates';
  link: '';
  setting_key: 'onboarding_document_templates';
  values: [true, false];
}
export interface IOnboardingNotifyCandidateOnTeamMemberStageCompletionTemplate {
  default_value: false;
  description: "If toggled on, a setting will be added that allows the user to decide whether to notify candidates when a team member stage is completed in onboarding";
  name: 'Onboarding notify candidate on team member stage completion';
  link: '';
  setting_key: 'onboarding_notify_candidate_on_team_member_stage_completion';
  values: [true, false];
}
export interface IOnboardingProcessStepDeadlockHandlersTemplate {
  default_value: false;
  description: "If toggled on, we will enable deadlock handlers for onboarding process steps (at the moment, just email and team_member_action)";
  name: 'Onboarding process step deadlock handlers';
  link: '';
  setting_key: 'onboarding_process_step_deadlock_handlers';
  values: [true, false];
}
export interface IOnboardingV1Template {
  default_value: true;
  description: "Allows users to continue using onboarding V1 can be disabled once the client is switched over to the new system";
  name: 'Onboarding V1';
  link: '';
  setting_key: 'onboarding_v1';
  values: [true, false];
}
export interface IOnboardingV2Template {
  default_value: false;
  description: "Enables onboarding V2 this toggle and onboarding v1 can be enabled together for switch over";
  name: 'Onboarding V2';
  link: '';
  setting_key: 'onboarding_v2';
  values: [true, false];
}
export interface IOnboardingV2AssignedStepNotificationsTemplate {
  default_value: false;
  description: "Allows users to decide whether they want to receive assigned onboarding steps notifications via email, in-app or Slack";
  name: 'Onboarding V2 assigned step notifications';
  link: '';
  setting_key: 'onboarding_v2_assigned_step_notifications';
  values: [true, false];
}
export interface IOnboardingV2BackgroundCheckNeedReviewOptOutTemplate {
  default_value: true;
  description: "If toggled on, background checks no longer need to be explictly overridden before being marked as complete in onboarding V2";
  name: 'Onboarding V2 background check need review opt-out';
  link: '';
  setting_key: 'onboarding_v2_background_check_need_review_opt_out';
  values: [true, false];
}
export interface IOnboardingV2EnforceJobVisibilitiesTemplate {
  default_value: false;
  description: "Uses job visibilities to determine which onboarding applications can be shown to a user";
  name: 'Onboarding V2 enforce job visibilities';
  link: '';
  setting_key: 'onboarding_v2_enforce_job_visibilities';
  values: [true, false];
}
export interface IOnboardingV2NotificationCandidateMessagesTemplate {
  default_value: false;
  description: "Allows users to receive candidate message notifications only when candidate is in onboarding";
  name: 'Onboarding V2 notification candidate messages';
  link: '';
  setting_key: 'onboarding_v2_notification_candidate_messages';
  values: [true, false];
}
export interface IOnboardingV2ProgressTrackerUpdatesTemplate {
  default_value: true;
  description: "Default on, should be removed as a company setting. Left because of the carnage in the tests when removed";
  name: 'Onboarding V2 progress tracker updates';
  link: '';
  setting_key: 'onboarding_v2_progress_tracker_updates';
  values: [true, false];
}
export interface IOnboardingV2ReportingTemplate {
  default_value: true;
  description: "Default on. Code and company setting need to be removed.";
  name: 'Onboarding V2 reporting';
  link: '';
  setting_key: 'onboarding_v2_reporting';
  values: [true, false];
}
export interface IOnboardingV2StartDateChangeReasonsTemplate {
  default_value: true;
  description: "Allows users to input and view start date change reasons when editing start date in Onboarding v2";
  name: 'Onboarding V2 start date change reasons';
  link: '';
  setting_key: 'onboarding_v2_start_date_change_reasons';
  values: [true, false];
}
export interface IOnboardingV2TurbochargerTemplate {
  default_value: false;
  description: "Improves onboarding v2 for candidates";
  name: 'Onboarding V2 performance enhancements';
  link: '';
  setting_key: 'onboarding_v2_turbocharger';
  values: [true, false];
}
export interface IOverridingJobAccessTemplate {
  default_value: false;
  description: "If toggled on, allows overriding job access to be enabled for users or access groups.";
  name: 'Overriding Job Access';
  link: '';
  setting_key: 'overriding_job_access';
  values: [true, false];
}
export interface IPersonalDetailsAutoUpdateTemplate {
  default_value: true;
  description: "If toggled on, when you update an application or candidate all other linked applications will also be updated. Applies to names, emails, phone numbers and address";
  name: 'Personal details auto update';
  link: '';
  setting_key: 'personal_details_auto_update';
  values: [true, false];
}
export interface IPinpointChecksPausedTemplate {
  default_value: false;
  description: "Users won't be able to order new Pinpoint background checks while the add-on is paused. They'll still be able to see and manage existing checks.";
  name: 'Pinpoint Background Checks (powered by Certn)';
  link: '';
  setting_key: 'pinpoint_checks_paused';
  values: [true, false];
}
export interface IPositionManagementTemplate {
  default_value: false;
  description: "If toggled on, users will be able to manage positions within the platform";
  name: 'Position Management';
  link: '';
  setting_key: 'position_management';
  values: [true, false];
}
export interface IPostmarkEventMonitoringTemplate {
  default_value: false;
  description: "If toggled on, we will log all postmark events that come in for this company";
  name: 'Postmark event monitoring';
  link: '';
  setting_key: 'postmark_event_monitoring';
  values: [true, false];
}
export interface IPremiumWorkflowAutomationsTemplate {
  default_value: false;
  description: "If toggled on, users will have access to all advanced Automations features with no limits. Requires Basic Automations to be turned on.";
  name: 'Advanced Automations';
  link: '';
  setting_key: 'premium_workflow_automations';
  values: [true, false];
}
export interface IPrivateCalendarEventsTemplate {
  default_value: true;
  description: "If toggled on, all events created in users calendars will be private";
  name: 'Add calendar events as private';
  link: '';
  setting_key: 'private_calendar_events';
  values: [true, false];
}
export interface IRadiusSearchTemplate {
  default_value: false;
  description: "If toggled on, users will be able to search applications, candidates and job seekers within a radius of a location";
  name: 'Radius search';
  link: '';
  setting_key: 'radius_search';
  values: [true, false];
}
export interface IReactSelectOnExternalJobsTemplate {
  default_value: false;
  description: "";
  name: 'Use the react select on the external job index pages. Added for accessibility purposes should not be toggled on';
  link: '';
  setting_key: 'react_select_on_external_jobs';
  values: [true, false];
}
export interface IRecruitmentAgenciesTemplate {
  default_value: false;
  description: "If toggled on, users will be able to manage recruitment agencies within the platform";
  name: 'Recruitment Agencies';
  link: '';
  setting_key: 'recruitment_agencies';
  values: [true, false];
}
export interface IRecruitmentAgencyLocationMatchingTemplate {
  default_value: false;
  description: "If toggled on, users will be able to assign locations to recruitment agencies and have applications automatically assigned to them";
  name: 'Recruitment Agency Location Matching';
  link: '';
  setting_key: 'recruitment_agency_location_matching';
  values: [true, false];
}
export interface IRedirectMovedJobToCopiedObjectTemplate {
  default_value: false;
  description: "If toggled on, users will be redirected to the copied job once they no longer have visibility over the job";
  name: 'Redirect job to copied object';
  link: '';
  setting_key: 'redirect_moved_job_to_copied_object';
  values: [true, false];
}
export interface IRedirectToCopiedObjectTemplate {
  default_value: false;
  description: "If toggled on, users and applicants will be redirected to the copied object following a platform migration";
  name: 'Redirect to copied object';
  link: '';
  setting_key: 'redirect_to_copied_object';
  values: [true, false];
}
export interface IRedirectToCustomSubdomainTemplate {
  default_value: true;
  description: "If toggled on, any request to the careers site will be automatically redirected to the companies custom subdomain";
  name: 'Redirect all careers site requests to custom subdomain';
  link: '';
  setting_key: 'redirect_to_custom_subdomain';
  values: [true, false];
}
export interface IReferenceCheckingTemplate {
  default_value: false;
  description: "If toggled on, users will be able to use the reference checking feature";
  name: 'Reference checking';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Reference-Checking-1.0-(Full-Release)-173';
  setting_key: 'reference_checking';
  values: [true, false];
}
export interface IReferenceCheckingPausedTemplate {
  default_value: false;
  description: "Users won't be able to request new references while the add-on is paused. They'll still be able to see and manage existing references.";
  name: 'Reference checking';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Reference-Checking-1.0-(Full-Release)-173';
  setting_key: 'reference_checking_paused';
  values: [true, false];
}
export interface IReferenceCheckingReviewFormsTemplate {
  default_value: false;
  description: "If toggled on, users will be able to create and complete review forms for reference checks. (Currently requires dev team to create a review template)";
  name: 'Reference checking review forms';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Reference-Checking-1.0-(Full-Release)-173';
  setting_key: 'reference_checking_review_forms';
  values: [true, false];
}
export interface IReferenceCheckingTimeBasedTemplate {
  default_value: true;
  description: "If toggled on, it will expose dynamic reference checking features";
  name: 'Dynamic Reference Checking';
  link: '';
  setting_key: 'reference_checking_time_based';
  values: [true, false];
}
export interface IReferralManagementTemplate {
  default_value: true;
  description: "If toggled on, clients will be able to manage referrals within the platform";
  name: 'Referral Management';
  link: '';
  setting_key: 'referral_management';
  values: [true, false];
}
export interface IReferralsUserNotificationDefaultsTemplate {
  default_value: false;
  description: "The default notification preferences for new referral users in /admin";
  name: 'Referral user notification defaults';
  link: '';
  setting_key: 'referrals_user_notification_defaults';
  values: [true, false];
}
export interface IRefreshCsrfTokenBeforeApplicationSubmitTemplate {
  default_value: false;
  description: "If toggled on, the application form will always fetch a fresh CSRF token before submission, regardless of session age.";
  name: 'Refresh CSRF Token Before Application Submit';
  link: '';
  setting_key: 'refresh_csrf_token_before_application_submit';
  values: [true, false];
}
export interface IRejectAllOtherApplicationsTemplate {
  default_value: false;
  description: "If toggled on, users will have access the ability to automatically reject all other applications when a candidate is moved to the hired stage using workflow automations";
  name: 'Reject all other applications';
  link: '';
  setting_key: 'reject_all_other_applications';
  values: [true, false];
}
export interface IRemoveCompTimeUnitOnOfferTemplate {
  default_value: false;
  description: "If toggled on, we will remove the compensation time unit from the offer letter form. Can NOT be used in conjunction with 'Enforce offer salary fields' or 'Require completion of all offer fields'";
  name: 'Remove compensation time unit on offer';
  link: '';
  setting_key: 'remove_comp_time_unit_on_offer';
  values: [true, false];
}
export interface IRemoveEmailFooterTemplate {
  default_value: false;
  description: "If toggled on, we will remove the standard email footer from all candidate emails sent from the platform";
  name: 'Remove email footer';
  link: '';
  setting_key: 'remove_email_footer';
  values: [true, false];
}
export interface IRemoveLogoFromEmailTemplateTemplate {
  default_value: false;
  description: "";
  name: 'Remove the company logo from the email template';
  link: '';
  setting_key: 'remove_logo_from_email_template';
  values: [true, false];
}
export interface IReportEmptyNotEmptyOperatorsTemplate {
  default_value: true;
  description: "Allows users to use is empty and is not empty as filter operators in custom reports";
  name: 'Report empty / not empty operators';
  link: '';
  setting_key: 'report_empty_not_empty_operators';
  values: [true, false];
}
export interface IReportOnlyCspTemplate {
  default_value: false;
  description: "If toggled on, we will switch the CSP to report only mode (default will enforce the CSP)";
  name: 'Switch CSP policy to report only for company careers site';
  link: '';
  setting_key: 'report_only_csp';
  values: [true, false];
}
export interface IRequireHeadcountTemplate {
  default_value: false;
  description: "If toggled on, users will be required to set a headcount when creating a job";
  name: 'Require headcount on job creation';
  link: '';
  setting_key: 'require_headcount';
  values: [true, false];
}
export interface IRestrictJobVisibilityTemplate {
  default_value: false;
  description: "If toggled on, users can create jobs that are only visible to users who are given direct access to them (i.e. not through assigned visibilities)";
  name: 'Restrict job visibility';
  link: '';
  setting_key: 'restrict_job_visibility';
  values: [true, false];
}
export interface IRestrictedCronofyOauthScopeTemplate {
  default_value: false;
  description: "";
  name: 'Limit the Cronofy scope to just read free busy. Please do not turn this on without confirming with the engineering team';
  link: '';
  setting_key: 'restricted_cronofy_oauth_scope';
  values: [true, false];
}
export interface ISavedViewsOpenStagesTemplate {
  default_value: true;
  description: "If toggled on, you can save views on open stages";
  name: 'Saved Views Open Stages';
  link: '';
  setting_key: 'saved_views_open_stages';
  values: [true, false];
}
export interface IScorecardSummaryTemplate {
  default_value: true;
  description: "If toggled on, we will automatically use AI to generate a summary of the scorecard";
  name: 'Scorecard Summary';
  link: '';
  setting_key: 'scorecard_summary';
  values: [true, false];
}
export interface ISemiPrivateCommentsTemplate {
  default_value: false;
  description: "";
  name: 'Allow company managers to view private comments';
  link: '';
  setting_key: 'semi_private_comments';
  values: [true, false];
}
export interface ISendDailyRemindersForOnboardingStagesTemplate {
  default_value: true;
  description: "If toggled on, users will be able to send daily reminders for onboarding stages";
  name: 'Send daily reminders for onboarding stages';
  link: '';
  setting_key: 'send_daily_reminders_for_onboarding_stages';
  values: [true, false];
}
export interface ISendPdfCopyOfApplicationTemplate {
  default_value: false;
  description: "If toggled on, candidates will be asked on the application form whether they want to send themselves a copy of their submitted application";
  name: 'Allow candidates to receive a pdf copy of their details when applying';
  link: '';
  setting_key: 'send_pdf_copy_of_application';
  values: [true, false];
}
export interface ISendRescheduledInterviewCancellationEventsTemplate {
  default_value: false;
  description: "If toggled on, we will send cancellation events and notifications for rescheduled interviews";
  name: 'Send Rescheduled Interview Cancellation Events';
  link: '';
  setting_key: 'send_rescheduled_interview_cancellation_events';
  values: [true, false];
}
export interface IShowAllCandidatesIndexTemplate {
  default_value: true;
  description: "If toggled on, the all candidates index will be shown on the primary nav, if toggled off it will be hidden on the nav (but the page will still be accessible at /admin/candidates).";
  name: 'Master all candidates view';
  link: '';
  setting_key: 'show_all_candidates_index';
  values: [true, false];
}
export interface IShowApiKeysOnceTemplate {
  default_value: false;
  description: "If toggled on, API key tokens will only be shown once during creation and cannot be viewed again. Existing API keys will also be hidden.";
  name: 'Show API keys once';
  link: '';
  setting_key: 'show_api_keys_once';
  values: [true, false];
}
export interface IShowCompensationByDefaultTemplate {
  default_value: true;
  description: "Toggles the default value of the show compensation field on the job form between 'Yes' and 'No'.";
  name: 'Show compensation by default';
  link: '';
  setting_key: 'show_compensation_by_default';
  values: [true, false];
}
export interface IShowDateInOfferHeaderTemplate {
  default_value: true;
  description: "If toggled on, we will show the date in the header on the offer letters";
  name: 'Show the date in the header on the offer letters';
  link: '';
  setting_key: 'show_date_in_offer_header';
  values: [true, false];
}
export interface IShowJobSeekersInAllCandidatesTemplate {
  default_value: false;
  description: "If toggled on, we will show job seekers in the all candidates view (as well as the talent pipeline). Enabling this can cause performance problems on the all candidates view so enable this with caution.";
  name: 'Show job seekers in the all candidates view';
  link: '';
  setting_key: 'show_job_seekers_in_all_candidates';
  values: [true, false];
}
export interface IShowPinpointCreditsMessagingTemplate {
  default_value: false;
  description: "If toggled on, users will see messaging about Pinpoint Credits in relevant areas of the application.";
  name: 'Show Pinpoint Credits Messaging';
  link: '';
  setting_key: 'show_pinpoint_credits_messaging';
  values: [true, false];
}
export interface ISignOffSpecificityV2Template {
  default_value: false;
  description: "If toggled on, instead of simply counting the number of conditions on a sign off workflow to determine which one to choose we will count the number of different properties";
  name: 'Sign-off specificity V2';
  link: '';
  setting_key: 'sign_off_specificity_v2';
  values: [true, false];
}
export interface ISkillsTemplate {
  default_value: true;
  description: "If toggled on, users will be able to add skills to candidates and filter on them";
  name: 'Allow managing and filtering on skills';
  link: '';
  setting_key: 'skills';
  values: [true, false];
}
export interface IStageDatesInExternalApplicationTemplate {
  default_value: false;
  description: "If toggled on, we will add the stage group movement dates into the external API as attributes";
  name: 'Stage group movement dates into the API';
  link: '';
  setting_key: 'stage_dates_in_external_application';
  values: [true, false];
}
export interface IStageGroupVisibilitiesTemplate {
  default_value: false;
  description: "If toggled on, will expose stage group visibilities for users and access groups";
  name: 'Stage group visibilities';
  link: '';
  setting_key: 'stage_group_visibilities';
  values: [true, false];
}
export interface IStageVisibilitiesTemplate {
  default_value: true;
  description: "If toggled on, users can be assigned visibility over stages. Only turn this on if absolutely required as there is a performance consideration";
  name: 'Can assign visibilities to stages';
  link: '';
  setting_key: 'stage_visibilities';
  values: [true, false];
}
export interface IStateFiltersTemplate {
  default_value: true;
  description: "If toggled on, we will show state filters on the job and candidate index pages";
  name: 'State filters';
  link: '';
  setting_key: 'state_filters';
  values: [true, false];
}
export interface IStrictOfccpComplianceTemplate {
  default_value: false;
  description: "As of 14 April 2023 this just means you cannot gather candidates date of birth, and you cannot delete jobs";
  name: 'Restrict any action that does not comply with OFCCP';
  link: '';
  setting_key: 'strict_ofccp_compliance';
  values: [true, false];
}
export interface IStructuredSectionsTemplate {
  default_value: true;
  description: "If toggled on, we will allow users to create structured sections";
  name: 'Structured sections';
  link: '';
  setting_key: 'structured_sections';
  values: [true, false];
}
export interface ITalentPipelineTemplate {
  default_value: true;
  description: "If toggled on, clients will be able to accept speculative applications and use the talent pipeline";
  name: 'Enable the talent pipeline';
  link: '';
  setting_key: 'talent_pipeline';
  values: [true, false];
}
export interface ITalentPipelineV2Template {
  default_value: true;
  description: "If toggled on, clients will have access to the new talent pipeline which includes ability to create and manage talent pools";
  name: 'Talent Pipeline V2';
  link: '';
  setting_key: 'talent_pipeline_v2';
  values: [true, false];
}
export interface ITaskManagementTemplate {
  default_value: true;
  description: "If toggled on, clients will be able to create tasks within the platform";
  name: 'Task Management';
  link: '';
  setting_key: 'task_management';
  values: [true, false];
}
export interface ITeamRejectionNotificationTemplate {
  default_value: false;
  description: "If toggled on, sign off rejection notifications will be sent to anyone that has permissions and visibilities that allow them to edit the resource. If toggled off, the rejection notification is only sent to the creator";
  name: 'Send sign off rejection notifications to anyone with visibility';
  link: '';
  setting_key: 'team_rejection_notification';
  values: [true, false];
}
export interface IUpdatedRequisitionsCardsTemplate {
  default_value: false;
  description: "If toggled on, we will show updated requisition cards on the requisitions page";
  name: 'Updated requisitions cards';
  link: '';
  setting_key: 'updated_requisitions_cards';
  values: [true, false];
}
export interface IUpsellReferenceCheckingTemplate {
  default_value: false;
  description: "If toggled on, users will see upsell messaging for credits in Reference Checking";
  name: 'Upsell Reference Checking';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Reference-Checking-Upsell-Journey-305';
  setting_key: 'upsell_reference_checking';
  values: [true, false];
}
export interface IUseChunkedReportFilteringTemplate {
  default_value: false;
  description: "When enabled, the report system collects and filters record IDs in chunks to prevent SQL timeouts. Recommended for companies with 500k+ records. Requires experimental_parallel_report_generation to be enabled.";
  name: 'Use chunked report filtering for large datasets';
  link: '';
  setting_key: 'use_chunked_report_filtering';
  values: [true, false];
}
export interface IUseCompanyFromAddressTemplate {
  default_value: false;
  description: "";
  name: 'Use company@pinpoint.email instead of uuid@pinpoint.email when sending emails';
  link: '';
  setting_key: 'use_company_from_address';
  values: [true, false];
}
export interface IUseFallbackSignOffWorkflowsTemplate {
  default_value: false;
  description: "If toggled on, for approvable resources with no matching workflows the approval workflow selection engine will try to select the first sign-off workflow with no conditions that applies to that type of resource before returning nothing";
  name: 'Use fallback workflows when approvable resources have no matching sign-off workflows';
  link: '';
  setting_key: 'use_fallback_sign_off_workflows';
  values: [true, false];
}
export interface IUsePlanetscaleOptimizedCandidateQueriesTemplate {
  default_value: false;
  description: "Use JOIN-based queries instead of subqueries in CandidatePolicy for PlanetScale compatibility. Enables gradual rollout of performance optimization for large companies.";
  name: 'PlanetScale optimized candidate queries';
  link: '';
  setting_key: 'use_planetscale_optimized_candidate_queries';
  values: [true, false];
}
export interface IUseReportDateIndexesTemplate {
  default_value: false;
  description: "When enabled, candidate reports use the DateIndex table for date filtering instead of querying the applications table directly. Requires 'Generate report date indexes' to be enabled and data to be backfilled.";
  name: 'Use report date indexes';
  link: '';
  setting_key: 'use_report_date_indexes';
  values: [true, false];
}
export interface IVariableSignOffSignatoriesTemplate {
  default_value: false;
  description: "This replaces the old sign off workflow behaviour and allows variable signatories in the sign off workflows";
  name: 'Approval workflows v2';
  link: '';
  setting_key: 'variable_sign_off_signatories';
  values: [true, false];
}
export interface IVideoInterviewWilloPausedTemplate {
  default_value: false;
  description: "Users won't be able to invite candidates to Pinpoint video interviews while the add-on is paused. They'll still be able to see and manage existing video interviews.";
  name: 'Video Interviews (powered by Willo)';
  link: '';
  setting_key: 'video_interview_willo_paused';
  values: [true, false];
}
export interface IVisibleOtherApplicationsTemplate {
  default_value: false;
  description: "";
  name: 'Show other applications regardless of visibilities';
  link: '';
  setting_key: 'visible_other_applications';
  values: [true, false];
}
export interface IVonqV2Template {
  default_value: true;
  description: "If toggled on, users will be using the vonq API to search for products, rather than the boards we add in /platform. We need to transition everyone over to this, so if it is on do not turn it off";
  name: 'Use the Vonq V2 API';
  link: '';
  setting_key: 'vonq_v2';
  values: [true, false];
}
export interface IWaypointLoggingTemplate {
  default_value: false;
  description: "If toggled on, we will be able to log waypoint events to a separate database to assist with debugging";
  name: 'Waypoint logging';
  link: '';
  setting_key: 'waypoint_logging';
  values: [true, false];
}
export interface IWhitelabelledBackgroundChecksMspTemplate {
  default_value: false;
  description: "If toggled on, users will have access to the MSP features for whitelabelled background checks (requires whitelabelled_certn_centric_background_checks to be enabled)";
  name: 'Whitelabelled Background Checks MSP';
  link: '';
  setting_key: 'whitelabelled_background_checks_msp';
  values: [true, false];
}
export interface IWhitelabelledBackgroundChecksMspUatTemplate {
  default_value: false;
  description: "If toggled on, users will have access to the MSP features for whitelabelled background checks that are currently in UAT (requires whitelabelled_certn_centric_background_checks and whitelabelled_background_checks_msp to be enabled)";
  name: 'Whitelabelled Background Checks MSP UAT';
  link: '';
  setting_key: 'whitelabelled_background_checks_msp_uat';
  values: [true, false];
}
export interface IWhitelabelledCertnCentricBackgroundChecksTemplate {
  default_value: false;
  description: "If toggled on, users will be able to use a whitelabelled version of Certn for background checks";
  name: 'Whitelabelled Certn-Centric Background Checks';
  link: '';
  setting_key: 'whitelabelled_certn_centric_background_checks';
  values: [true, false];
}
export interface IWilloPinpointVideoInterviewingTemplate {
  default_value: false;
  description: "If toggled on, users will be able to use whitelabelled Willo for video interviewing";
  name: 'Pinpoint Video Interviewing (powered by Willo)';
  link: 'https://pinpoint.fibery.io/Databases/Projects/Willo-Pinpoint-Video-Interviewing-142';
  setting_key: 'willo_pinpoint_video_interviewing';
  values: [true, false];
}
export interface IWismCachedOnboardingApplicationTemplate {
  default_value: false;
  description: "Performance optimization - caches OnboardingApplication during Wism execution to reduce N+1 queries";
  name: 'Wism cached onboarding application';
  link: '';
  setting_key: 'wism_cached_onboarding_application';
  values: [true, false];
}
export interface IWismMetricsTrackingTemplate {
  default_value: false;
  description: "Enables Datadog metrics logging for WISM execution (duration, query count). Used to measure performance with and without optimizations.";
  name: 'Wism metrics tracking';
  link: '';
  setting_key: 'wism_metrics_tracking';
  values: [true, false];
}
export interface IWorkflowAutomationTemplate {
  default_value: false;
  description: "If toggled on, users will be able to create and manage job automation templates, and apply them directly to jobs when creating or editing jobs. Note - This is a legacy automations feature which we plan to deprecate. Please do not enable without checking with RevOps first.";
  name: 'Job Automations';
  link: '';
  setting_key: 'workflow_automation';
  values: [true, false];
}
export interface IWorkflowAutomationV2Template {
  default_value: false;
  description: "If toggled on, users will have access to Automations, with limits to basic features only, unless the Advanced Automations add on is also enabled.";
  name: 'Basic Automations';
  link: '';
  setting_key: 'workflow_automation_v2';
  values: [true, false];
}
export interface IYoutubeCookieManagementTemplate {
  default_value: false;
  description: "If toggled on, we will add YouTube cookies to the cookie banner and disable YouTube embeds if cookies are not accepted. This only needs to be enabled if users are using YouTube embeds on your careers site.";
  name: 'YouTube cookie management';
  link: '';
  setting_key: 'youtube_cookie_management';
  values: [true, false];
}
export interface IZincPollingProcessOnboardingAnswersTemplate {
  default_value: false;
  description: "If toggled on, we will use polling to Zinc result endpoint to process onboarding answers in lieu of webhooks.";
  name: 'Use polling to Zinc result endpoint to process onboarding answers';
  link: '';
  setting_key: 'zinc_polling_process_onboarding_answers';
  values: [true, false];
}

export type CompanySettingTemplate =
  | IAccessibleDateAndPhoneTemplate
  | IAddCcAndBccToEmailTemplate
  | IAdditionalPermissionsTemplate
  | IAdditionalStatusesTemplate
  | IAdvancedReportingTemplate
  | IAiCriteriaScoreTemplate
  | IAiCustomFieldsTemplate
  | IAllowBulkPoolTemplate
  | IAllowCoverLettersTemplate
  | IAllowCreatingCompanyTeamsTemplate
  | IAllowDeiFieldsInBulkApplicationUploadTemplate
  | IAllowEditingJobRequisitionFieldsTemplate
  | IAllowInactiveStructuresTemplate
  | IAllowMydataDeletionTemplate
  | IAllowedEmailSuffixesOnlyForInternalJobsTemplate
  | IAlternativeSamlClaimIdentifierTemplate
  | IAlwaysSendNotificationsTemplate
  | IAnonymousScreeningTemplate
  | IApiLoggingTemplate
  | IApiRedesignTemplate
  | IApplicationNationalIdentifiersTemplate
  | IApprovalListsTemplate
  | IApprovalWorkflowLoggingTemplate
  | IApprovalWorkflowsAdditionalInformationTemplate
  | IAutoTranslateTemplate
  | IAutofillOfferFieldsFromJobFieldsTemplate
  | IAutomaticAssignmentToOnboardingImprovementsTemplate
  | IAutomaticSftpReportEncryptionTemplate
  | IAutomaticallyRejectReferralsTemplate
  | IBasicConsentManagementTemplate
  | IBulkActionsOpenStagesTemplate
  | IBulkCsvEditingTemplate
  | IBulkDownloadTemplate
  | IBulkEmailJobSeekersTemplate
  | ICachedJobAndStageVisibilitiesTemplate
  | ICanDeleteScorecardsTemplate
  | ICanSkipSignOffStageTemplate
  | ICandidateAssessmentWorkflowAutomationTriggerTemplate
  | ICandidateCopilotTemplate
  | ICandidateCustomFieldsTemplate
  | ICandidateDetailsInOfferHeaderTemplate
  | ICandidateJobPreferencesTemplate
  | ICandidateSurveysTemplate
  | ICareersPageAiAuditorTemplate
  | ICareersSiteBuilderV2Template
  | ICareersSiteChatbotTemplate
  | ICareersSiteChatbotVoicePromptsTemplate
  | ICareersSiteFormCaptchasTemplate
  | IChatbotApplicationFlowTemplate
  | IClientsideJobPostingFilteringTemplate
  | IConditionalCustomFieldsTemplate
  | ICreateCachedJobAndStageVisibilitiesTemplate
  | ICreateRequisitionsForExistingJobsTemplate
  | ICustomFieldOptionLabelsTemplate
  | ICustomJobPostingLocationsTemplate
  | ICustomisableColumnsTemplate
  | ICvParsingTemplate
  | ICvRedactionTemplate
  | IDeiReportsTemplate
  | IDelayEssentialCookieSettingTemplate
  | IDetermineInterviewHostTemplate
  | IDisableCookieDialogTemplate
  | IDisableIndeedFeedTemplate
  | IDisablePublicHiringProfilesTemplate
  | IDisableReferralUserNotificationsTemplate
  | IDisableWillupdateurlTemplate
  | IDisallowPersonalRefereeEmailsTemplate
  | IDisplayApprovalStatusTemplate
  | IDisplayTeamMemberStagesInOnboardingCandidatePortalTemplate
  | IDocumentTemplatesMultipleSignersTemplate
  | IDocusignLoggingTemplate
  | IDownloadPdfApplicationTemplate
  | IEditOfferBeforeSendTemplate
  | IEditSentOffersTemplate
  | IEditSentOffersAllFieldsTemplate
  | IEditableQuestionAnswersTemplate
  | IEmailLinkTrackingTemplate
  | IEmailOpenTrackingTemplate
  | IEmailTemplateTableViewTemplate
  | IEnableCronofyEventDeletionTrackingTemplate
  | IEnforceAllOfferFieldsRequiredTemplate
  | IEnforceAllOfferSalaryFieldTemplate
  | IEssentialCookiesOnlyTemplate
  | IExperimentalParallelReportGenerationTemplate
  | IExperimentalReportFilteringTemplate
  | IExternalRecruitersTemplate
  | IExtraMonitoringForAutomationsTemplate
  | IFacebookAdvertTemplate
  | IFacebookAdvertExcludeInstagramTemplate
  | IFilledTabTemplate
  | IFilterReportsByCandidateCurrentStageTemplate
  | IGenerateReportDateIndexesTemplate
  | IGoogleAnalyticsEnabledTemplate
  | IGoogleTranslateWidgetTemplate
  | IGroupAssessmentsTemplate
  | IGroupInterviewsTemplate
  | IGroupedJobsTemplate
  | IHideCvDownloadTemplate
  | IHideDiscardedEqTemplatesInReportsTemplate
  | IHideIndividualConnectTemplate
  | IHybridInterviewsTemplate
  | IIncludeOpenDateOnJobsPageTemplate
  | IIndeedDispositionSyncTemplate
  | IIndeedFeedStagesTemplate
  | IIndeedJobPostingsApiTemplate
  | IIndeedThemeSourcenameTemplate
  | IIndeedUseSharedClientIdTemplate
  | IInferredAnswersTemplate
  | IInsightsHubGlobalFiltersTemplate
  | IInstantImpactClientTemplate
  | IIntegerAiCustomFieldsTemplate
  | IIntegrationPluginsTemplate
  | IInternshipProgrammeTemplate
  | IInterviewInviteRestrictionTemplate
  | IJobPostingAddressTemplate
  | IJobRequisitionManagementTemplate
  | ILimitOnboardingToHiredCandidatesTemplate
  | ILinkedinJobPostingsTemplate
  | ILinkedinRscTemplate
  | ILocationCityStateTemplate
  | IManageCommunicationPreferencesTemplate
  | IManuallyAddedCandidatesRequiredQuestionsTemplate
  | IManuallySendOffersTemplate
  | IMarineCvParsingTemplate
  | IMasterJobApplicationsViewTemplate
  | IMaxApplicationsTemplate
  | IMergeAttachmentsToPdfTemplate
  | IMonitorSamlTemplate
  | IMonitorWithRumTemplate
  | IMoveToAnyJobTemplate
  | IMoveToHiredOnOfferAcceptanceTemplate
  | IMultipleCompanyThemesTemplate
  | IMultipleJobPostingsTemplate
  | IMultipleQuestionCollectionsTemplate
  | IMultipleVideoInterviewProviderSupportTemplate
  | INewConferencingProviderUxTemplate
  | INewCustomFieldReportingFiltersTemplate
  | INewWorkflowAutomationPricingTemplate
  | INoReplyEmailsTemplate
  | INotifyInterestedCandidatesTemplate
  | IOfferManagementTemplate
  | IOfferPacksTemplate
  | IOfferRetractedNotificationTemplate
  | IOfferSplittingTemplate
  | IOnboardingCandidateViewerRoleTemplate
  | IOnboardingDashboardStageStepOwnershipTemplate
  | IOnboardingDocumentTemplatesTemplate
  | IOnboardingNotifyCandidateOnTeamMemberStageCompletionTemplate
  | IOnboardingProcessStepDeadlockHandlersTemplate
  | IOnboardingV1Template
  | IOnboardingV2Template
  | IOnboardingV2AssignedStepNotificationsTemplate
  | IOnboardingV2BackgroundCheckNeedReviewOptOutTemplate
  | IOnboardingV2EnforceJobVisibilitiesTemplate
  | IOnboardingV2NotificationCandidateMessagesTemplate
  | IOnboardingV2ProgressTrackerUpdatesTemplate
  | IOnboardingV2ReportingTemplate
  | IOnboardingV2StartDateChangeReasonsTemplate
  | IOnboardingV2TurbochargerTemplate
  | IOverridingJobAccessTemplate
  | IPersonalDetailsAutoUpdateTemplate
  | IPinpointChecksPausedTemplate
  | IPositionManagementTemplate
  | IPostmarkEventMonitoringTemplate
  | IPremiumWorkflowAutomationsTemplate
  | IPrivateCalendarEventsTemplate
  | IRadiusSearchTemplate
  | IReactSelectOnExternalJobsTemplate
  | IRecruitmentAgenciesTemplate
  | IRecruitmentAgencyLocationMatchingTemplate
  | IRedirectMovedJobToCopiedObjectTemplate
  | IRedirectToCopiedObjectTemplate
  | IRedirectToCustomSubdomainTemplate
  | IReferenceCheckingTemplate
  | IReferenceCheckingPausedTemplate
  | IReferenceCheckingReviewFormsTemplate
  | IReferenceCheckingTimeBasedTemplate
  | IReferralManagementTemplate
  | IReferralsUserNotificationDefaultsTemplate
  | IRefreshCsrfTokenBeforeApplicationSubmitTemplate
  | IRejectAllOtherApplicationsTemplate
  | IRemoveCompTimeUnitOnOfferTemplate
  | IRemoveEmailFooterTemplate
  | IRemoveLogoFromEmailTemplateTemplate
  | IReportEmptyNotEmptyOperatorsTemplate
  | IReportOnlyCspTemplate
  | IRequireHeadcountTemplate
  | IRestrictJobVisibilityTemplate
  | IRestrictedCronofyOauthScopeTemplate
  | ISavedViewsOpenStagesTemplate
  | IScorecardSummaryTemplate
  | ISemiPrivateCommentsTemplate
  | ISendDailyRemindersForOnboardingStagesTemplate
  | ISendPdfCopyOfApplicationTemplate
  | ISendRescheduledInterviewCancellationEventsTemplate
  | IShowAllCandidatesIndexTemplate
  | IShowApiKeysOnceTemplate
  | IShowCompensationByDefaultTemplate
  | IShowDateInOfferHeaderTemplate
  | IShowJobSeekersInAllCandidatesTemplate
  | IShowPinpointCreditsMessagingTemplate
  | ISignOffSpecificityV2Template
  | ISkillsTemplate
  | IStageDatesInExternalApplicationTemplate
  | IStageGroupVisibilitiesTemplate
  | IStageVisibilitiesTemplate
  | IStateFiltersTemplate
  | IStrictOfccpComplianceTemplate
  | IStructuredSectionsTemplate
  | ITalentPipelineTemplate
  | ITalentPipelineV2Template
  | ITaskManagementTemplate
  | ITeamRejectionNotificationTemplate
  | IUpdatedRequisitionsCardsTemplate
  | IUpsellReferenceCheckingTemplate
  | IUseChunkedReportFilteringTemplate
  | IUseCompanyFromAddressTemplate
  | IUseFallbackSignOffWorkflowsTemplate
  | IUsePlanetscaleOptimizedCandidateQueriesTemplate
  | IUseReportDateIndexesTemplate
  | IVariableSignOffSignatoriesTemplate
  | IVideoInterviewWilloPausedTemplate
  | IVisibleOtherApplicationsTemplate
  | IVonqV2Template
  | IWaypointLoggingTemplate
  | IWhitelabelledBackgroundChecksMspTemplate
  | IWhitelabelledBackgroundChecksMspUatTemplate
  | IWhitelabelledCertnCentricBackgroundChecksTemplate
  | IWilloPinpointVideoInterviewingTemplate
  | IWismCachedOnboardingApplicationTemplate
  | IWismMetricsTrackingTemplate
  | IWorkflowAutomationTemplate
  | IWorkflowAutomationV2Template
  | IYoutubeCookieManagementTemplate
  | IZincPollingProcessOnboardingAnswersTemplate;

/**
 * Company settings which are now deprecated and should not be used in the application.
 */
 export const deprecatedCompanySettingsStrings: string[] = [
];

/**
 * Initial value for all company settings in the application.
 *
 */
export const companySettingsInitialValues: ICompanySettings = {
  accessible_date_and_phone: false,
  add_cc_and_bcc_to_email: false,
  additional_permissions: false,
  additional_statuses: false,
  advanced_reporting: false,
  ai_criteria_score: true,
  ai_custom_fields: true,
  allow_bulk_pool: false,
  allow_cover_letters: false,
  allow_creating_company_teams: false,
  allow_dei_fields_in_bulk_application_upload: false,
  allow_editing_job_requisition_fields: false,
  allow_inactive_structures: false,
  allow_mydata_deletion: true,
  allowed_email_suffixes_only_for_internal_jobs: false,
  alternative_saml_claim_identifier: false,
  always_send_notifications: false,
  anonymous_screening: true,
  api_logging: true,
  api_redesign: true,
  application_national_identifiers: false,
  approval_lists: false,
  approval_workflow_logging: false,
  approval_workflows_additional_information: false,
  auto_translate: false,
  autofill_offer_fields_from_job_fields: false,
  automatic_assignment_to_onboarding_improvements: true,
  automatic_sftp_report_encryption: false,
  automatically_reject_referrals: false,
  basic_consent_management: false,
  bulk_actions_open_stages: true,
  bulk_csv_editing: false,
  bulk_download: false,
  bulk_email_job_seekers: false,
  cached_job_and_stage_visibilities: false,
  can_delete_scorecards: false,
  can_skip_sign_off_stage: false,
  candidate_assessment_workflow_automation_trigger: false,
  candidate_copilot: false,
  candidate_custom_fields: false,
  candidate_details_in_offer_header: false,
  candidate_job_preferences: false,
  candidate_surveys: true,
  careers_page_ai_auditor: false,
  careers_site_builder_v2: false,
  careers_site_chatbot: false,
  careers_site_chatbot_voice_prompts: false,
  careers_site_form_captchas: false,
  chatbot_application_flow: false,
  clientside_job_posting_filtering: false,
  conditional_custom_fields: true,
  create_cached_job_and_stage_visibilities: false,
  create_requisitions_for_existing_jobs: true,
  custom_field_option_labels: false,
  custom_job_posting_locations: false,
  customisable_columns: true,
  cv_parsing: true,
  cv_redaction: true,
  dei_reports: false,
  delay_essential_cookie_setting: false,
  determine_interview_host: false,
  disable_cookie_dialog: false,
  disable_indeed_feed: false,
  disable_public_hiring_profiles: false,
  disable_referral_user_notifications: false,
  disable_willUpdateUrl: false,
  disallow_personal_referee_emails: false,
  display_approval_status: true,
  display_team_member_stages_in_onboarding_candidate_portal: false,
  document_templates_multiple_signers: false,
  docusign_logging: false,
  download_pdf_application: false,
  edit_offer_before_send: true,
  edit_sent_offers: false,
  edit_sent_offers_all_fields: false,
  editable_question_answers: false,
  email_link_tracking: true,
  email_open_tracking: true,
  email_template_table_view: false,
  enable_cronofy_event_deletion_tracking: false,
  enforce_all_offer_fields_required: false,
  enforce_all_offer_salary_field: false,
  essential_cookies_only: false,
  experimental_parallel_report_generation: false,
  experimental_report_filtering: false,
  external_recruiters: true,
  extra_monitoring_for_automations: false,
  facebook_advert: false,
  facebook_advert_exclude_instagram: false,
  filled_tab: false,
  filter_reports_by_candidate_current_stage: true,
  generate_report_date_indexes: false,
  google_analytics_enabled: false,
  google_translate_widget: false,
  group_assessments: false,
  group_interviews: false,
  grouped_jobs: false,
  hide_cv_download: false,
  hide_discarded_eq_templates_in_reports: true,
  hide_individual_connect: false,
  hybrid_interviews: true,
  include_open_date_on_jobs_page: false,
  indeed_disposition_sync: true,
  indeed_feed_stages: false,
  indeed_job_postings_api: false,
  indeed_theme_sourcename: false,
  indeed_use_shared_client_id: true,
  inferred_answers: false,
  insights_hub_global_filters: true,
  instant_impact_client: false,
  integer_ai_custom_fields: true,
  integration_plugins: false,
  internship_programme: false,
  interview_invite_restriction: false,
  job_posting_address: false,
  job_requisition_management: false,
  limit_onboarding_to_hired_candidates: false,
  linkedin_job_postings: false,
  linkedin_rsc: true,
  location_city_state: false,
  manage_communication_preferences: true,
  manually_added_candidates_required_questions: false,
  manually_send_offers: false,
  marine_cv_parsing: false,
  master_job_applications_view: false,
  max_applications: false,
  merge_attachments_to_pdf: false,
  monitor_saml: false,
  monitor_with_rum: false,
  move_to_any_job: false,
  move_to_hired_on_offer_acceptance: true,
  multiple_company_themes: false,
  multiple_job_postings: false,
  multiple_question_collections: false,
  multiple_video_interview_provider_support: false,
  new_conferencing_provider_ux: false,
  new_custom_field_reporting_filters: true,
  new_workflow_automation_pricing: true,
  no_reply_emails: false,
  notify_interested_candidates: false,
  offer_management: true,
  offer_packs: false,
  offer_retracted_notification: false,
  offer_splitting: false,
  onboarding_candidate_viewer_role: false,
  onboarding_dashboard_stage_step_ownership: true,
  onboarding_document_templates: true,
  onboarding_notify_candidate_on_team_member_stage_completion: false,
  onboarding_process_step_deadlock_handlers: false,
  onboarding_v1: true,
  onboarding_v2: false,
  onboarding_v2_assigned_step_notifications: false,
  onboarding_v2_background_check_need_review_opt_out: true,
  onboarding_v2_enforce_job_visibilities: false,
  onboarding_v2_notification_candidate_messages: false,
  onboarding_v2_progress_tracker_updates: true,
  onboarding_v2_reporting: true,
  onboarding_v2_start_date_change_reasons: true,
  onboarding_v2_turbocharger: false,
  overriding_job_access: false,
  personal_details_auto_update: true,
  pinpoint_checks_paused: false,
  position_management: false,
  postmark_event_monitoring: false,
  premium_workflow_automations: false,
  private_calendar_events: true,
  radius_search: false,
  react_select_on_external_jobs: false,
  recruitment_agencies: false,
  recruitment_agency_location_matching: false,
  redirect_moved_job_to_copied_object: false,
  redirect_to_copied_object: false,
  redirect_to_custom_subdomain: true,
  reference_checking: false,
  reference_checking_paused: false,
  reference_checking_review_forms: false,
  reference_checking_time_based: true,
  referral_management: true,
  referrals_user_notification_defaults: false,
  refresh_csrf_token_before_application_submit: false,
  reject_all_other_applications: false,
  remove_comp_time_unit_on_offer: false,
  remove_email_footer: false,
  remove_logo_from_email_template: false,
  report_empty_not_empty_operators: true,
  report_only_csp: false,
  require_headcount: false,
  restrict_job_visibility: false,
  restricted_cronofy_oauth_scope: false,
  saved_views_open_stages: true,
  scorecard_summary: true,
  semi_private_comments: false,
  send_daily_reminders_for_onboarding_stages: true,
  send_pdf_copy_of_application: false,
  send_rescheduled_interview_cancellation_events: false,
  show_all_candidates_index: true,
  show_api_keys_once: false,
  show_compensation_by_default: true,
  show_date_in_offer_header: true,
  show_job_seekers_in_all_candidates: false,
  show_pinpoint_credits_messaging: false,
  sign_off_specificity_v2: false,
  skills: true,
  stage_dates_in_external_application: false,
  stage_group_visibilities: false,
  stage_visibilities: true,
  state_filters: true,
  strict_ofccp_compliance: false,
  structured_sections: true,
  talent_pipeline: true,
  talent_pipeline_v2: true,
  task_management: true,
  team_rejection_notification: false,
  updated_requisitions_cards: false,
  upsell_reference_checking: false,
  use_chunked_report_filtering: false,
  use_company_from_address: false,
  use_fallback_sign_off_workflows: false,
  use_planetscale_optimized_candidate_queries: false,
  use_report_date_indexes: false,
  variable_sign_off_signatories: false,
  video_interview_willo_paused: false,
  visible_other_applications: false,
  vonq_v2: true,
  waypoint_logging: false,
  whitelabelled_background_checks_msp: false,
  whitelabelled_background_checks_msp_uat: false,
  whitelabelled_certn_centric_background_checks: false,
  willo_pinpoint_video_interviewing: false,
  wism_cached_onboarding_application: false,
  wism_metrics_tracking: false,
  workflow_automation: false,
  workflow_automation_v2: false,
  youtube_cookie_management: false,
  zinc_polling_process_onboarding_answers: false,
};

const CompanySettingsContext = React.createContext<ICompanySettings>(companySettingsInitialValues);

export const useCompanySettings = () => {
  const companySettings = React.useContext(CompanySettingsContext);

  return React.useMemo(
    () => ({
      isAccessibleDateAndPhoneEnabled: companySettings.accessible_date_and_phone,
      isAddCcAndBccToEmailEnabled: companySettings.add_cc_and_bcc_to_email,
      isAdditionalPermissionsEnabled: companySettings.additional_permissions,
      isAdditionalStatusesEnabled: companySettings.additional_statuses,
      isAdvancedReportingEnabled: companySettings.advanced_reporting,
      isAiCriteriaScoreEnabled: companySettings.ai_criteria_score,
      isAiCustomFieldsEnabled: companySettings.ai_custom_fields,
      isAllowBulkPoolEnabled: companySettings.allow_bulk_pool,
      isAllowCoverLettersEnabled: companySettings.allow_cover_letters,
      isAllowCreatingCompanyTeamsEnabled: companySettings.allow_creating_company_teams,
      isAllowDeiFieldsInBulkApplicationUploadEnabled: companySettings.allow_dei_fields_in_bulk_application_upload,
      isAllowEditingJobRequisitionFieldsEnabled: companySettings.allow_editing_job_requisition_fields,
      isAllowInactiveStructuresEnabled: companySettings.allow_inactive_structures,
      isAllowMydataDeletionEnabled: companySettings.allow_mydata_deletion,
      isAllowedEmailSuffixesOnlyForInternalJobsEnabled: companySettings.allowed_email_suffixes_only_for_internal_jobs,
      isAlternativeSamlClaimIdentifierEnabled: companySettings.alternative_saml_claim_identifier,
      isAlwaysSendNotificationsEnabled: companySettings.always_send_notifications,
      isAnonymousScreeningEnabled: companySettings.anonymous_screening,
      isApiLoggingEnabled: companySettings.api_logging,
      isApiRedesignEnabled: companySettings.api_redesign,
      isApplicationNationalIdentifiersEnabled: companySettings.application_national_identifiers,
      isApprovalListsEnabled: companySettings.approval_lists,
      isApprovalWorkflowLoggingEnabled: companySettings.approval_workflow_logging,
      isApprovalWorkflowsAdditionalInformationEnabled: companySettings.approval_workflows_additional_information,
      isAutoTranslateEnabled: companySettings.auto_translate,
      isAutofillOfferFieldsFromJobFieldsEnabled: companySettings.autofill_offer_fields_from_job_fields,
      isAutomaticAssignmentToOnboardingImprovementsEnabled: companySettings.automatic_assignment_to_onboarding_improvements,
      isAutomaticSftpReportEncryptionEnabled: companySettings.automatic_sftp_report_encryption,
      isAutomaticallyRejectReferralsEnabled: companySettings.automatically_reject_referrals,
      isBasicConsentManagementEnabled: companySettings.basic_consent_management,
      isBulkActionsOpenStagesEnabled: companySettings.bulk_actions_open_stages,
      isBulkCsvEditingEnabled: companySettings.bulk_csv_editing,
      isBulkDownloadEnabled: companySettings.bulk_download,
      isBulkEmailJobSeekersEnabled: companySettings.bulk_email_job_seekers,
      isCachedJobAndStageVisibilitiesEnabled: companySettings.cached_job_and_stage_visibilities,
      isCanDeleteScorecardsEnabled: companySettings.can_delete_scorecards,
      isCanSkipSignOffStageEnabled: companySettings.can_skip_sign_off_stage,
      isCandidateAssessmentWorkflowAutomationTriggerEnabled: companySettings.candidate_assessment_workflow_automation_trigger,
      isCandidateCopilotEnabled: companySettings.candidate_copilot,
      isCandidateCustomFieldsEnabled: companySettings.candidate_custom_fields,
      isCandidateDetailsInOfferHeaderEnabled: companySettings.candidate_details_in_offer_header,
      isCandidateJobPreferencesEnabled: companySettings.candidate_job_preferences,
      isCandidateSurveysEnabled: companySettings.candidate_surveys,
      isCareersPageAiAuditorEnabled: companySettings.careers_page_ai_auditor,
      isCareersSiteBuilderV2Enabled: companySettings.careers_site_builder_v2,
      isCareersSiteChatbotEnabled: companySettings.careers_site_chatbot,
      isCareersSiteChatbotVoicePromptsEnabled: companySettings.careers_site_chatbot_voice_prompts,
      isCareersSiteFormCaptchasEnabled: companySettings.careers_site_form_captchas,
      isChatbotApplicationFlowEnabled: companySettings.chatbot_application_flow,
      isClientsideJobPostingFilteringEnabled: companySettings.clientside_job_posting_filtering,
      isConditionalCustomFieldsEnabled: companySettings.conditional_custom_fields,
      isCreateCachedJobAndStageVisibilitiesEnabled: companySettings.create_cached_job_and_stage_visibilities,
      isCreateRequisitionsForExistingJobsEnabled: companySettings.create_requisitions_for_existing_jobs,
      isCustomFieldOptionLabelsEnabled: companySettings.custom_field_option_labels,
      isCustomJobPostingLocationsEnabled: companySettings.custom_job_posting_locations,
      isCustomisableColumnsEnabled: companySettings.customisable_columns,
      isCvParsingEnabled: companySettings.cv_parsing,
      isCvRedactionEnabled: companySettings.cv_redaction,
      isDeiReportsEnabled: companySettings.dei_reports,
      isDelayEssentialCookieSettingEnabled: companySettings.delay_essential_cookie_setting,
      isDetermineInterviewHostEnabled: companySettings.determine_interview_host,
      isDisableCookieDialogEnabled: companySettings.disable_cookie_dialog,
      isDisableIndeedFeedEnabled: companySettings.disable_indeed_feed,
      isDisablePublicHiringProfilesEnabled: companySettings.disable_public_hiring_profiles,
      isDisableReferralUserNotificationsEnabled: companySettings.disable_referral_user_notifications,
      isDisableWillupdateurlEnabled: companySettings.disable_willUpdateUrl,
      isDisallowPersonalRefereeEmailsEnabled: companySettings.disallow_personal_referee_emails,
      isDisplayApprovalStatusEnabled: companySettings.display_approval_status,
      isDisplayTeamMemberStagesInOnboardingCandidatePortalEnabled: companySettings.display_team_member_stages_in_onboarding_candidate_portal,
      isDocumentTemplatesMultipleSignersEnabled: companySettings.document_templates_multiple_signers,
      isDocusignLoggingEnabled: companySettings.docusign_logging,
      isDownloadPdfApplicationEnabled: companySettings.download_pdf_application,
      isEditOfferBeforeSendEnabled: companySettings.edit_offer_before_send,
      isEditSentOffersEnabled: companySettings.edit_sent_offers,
      isEditSentOffersAllFieldsEnabled: companySettings.edit_sent_offers_all_fields,
      isEditableQuestionAnswersEnabled: companySettings.editable_question_answers,
      isEmailLinkTrackingEnabled: companySettings.email_link_tracking,
      isEmailOpenTrackingEnabled: companySettings.email_open_tracking,
      isEmailTemplateTableViewEnabled: companySettings.email_template_table_view,
      isEnableCronofyEventDeletionTrackingEnabled: companySettings.enable_cronofy_event_deletion_tracking,
      isEnforceAllOfferFieldsRequiredEnabled: companySettings.enforce_all_offer_fields_required,
      isEnforceAllOfferSalaryFieldEnabled: companySettings.enforce_all_offer_salary_field,
      isEssentialCookiesOnlyEnabled: companySettings.essential_cookies_only,
      isExperimentalParallelReportGenerationEnabled: companySettings.experimental_parallel_report_generation,
      isExperimentalReportFilteringEnabled: companySettings.experimental_report_filtering,
      isExternalRecruitersEnabled: companySettings.external_recruiters,
      isExtraMonitoringForAutomationsEnabled: companySettings.extra_monitoring_for_automations,
      isFacebookAdvertEnabled: companySettings.facebook_advert,
      isFacebookAdvertExcludeInstagramEnabled: companySettings.facebook_advert_exclude_instagram,
      isFilledTabEnabled: companySettings.filled_tab,
      isFilterReportsByCandidateCurrentStageEnabled: companySettings.filter_reports_by_candidate_current_stage,
      isGenerateReportDateIndexesEnabled: companySettings.generate_report_date_indexes,
      isGoogleAnalyticsEnabledEnabled: companySettings.google_analytics_enabled,
      isGoogleTranslateWidgetEnabled: companySettings.google_translate_widget,
      isGroupAssessmentsEnabled: companySettings.group_assessments,
      isGroupInterviewsEnabled: companySettings.group_interviews,
      isGroupedJobsEnabled: companySettings.grouped_jobs,
      isHideCvDownloadEnabled: companySettings.hide_cv_download,
      isHideDiscardedEqTemplatesInReportsEnabled: companySettings.hide_discarded_eq_templates_in_reports,
      isHideIndividualConnectEnabled: companySettings.hide_individual_connect,
      isHybridInterviewsEnabled: companySettings.hybrid_interviews,
      isIncludeOpenDateOnJobsPageEnabled: companySettings.include_open_date_on_jobs_page,
      isIndeedDispositionSyncEnabled: companySettings.indeed_disposition_sync,
      isIndeedFeedStagesEnabled: companySettings.indeed_feed_stages,
      isIndeedJobPostingsApiEnabled: companySettings.indeed_job_postings_api,
      isIndeedThemeSourcenameEnabled: companySettings.indeed_theme_sourcename,
      isIndeedUseSharedClientIdEnabled: companySettings.indeed_use_shared_client_id,
      isInferredAnswersEnabled: companySettings.inferred_answers,
      isInsightsHubGlobalFiltersEnabled: companySettings.insights_hub_global_filters,
      isInstantImpactClientEnabled: companySettings.instant_impact_client,
      isIntegerAiCustomFieldsEnabled: companySettings.integer_ai_custom_fields,
      isIntegrationPluginsEnabled: companySettings.integration_plugins,
      isInternshipProgrammeEnabled: companySettings.internship_programme,
      isInterviewInviteRestrictionEnabled: companySettings.interview_invite_restriction,
      isJobPostingAddressEnabled: companySettings.job_posting_address,
      isJobRequisitionManagementEnabled: companySettings.job_requisition_management,
      isLimitOnboardingToHiredCandidatesEnabled: companySettings.limit_onboarding_to_hired_candidates,
      isLinkedinJobPostingsEnabled: companySettings.linkedin_job_postings,
      isLinkedinRscEnabled: companySettings.linkedin_rsc,
      isLocationCityStateEnabled: companySettings.location_city_state,
      isManageCommunicationPreferencesEnabled: companySettings.manage_communication_preferences,
      isManuallyAddedCandidatesRequiredQuestionsEnabled: companySettings.manually_added_candidates_required_questions,
      isManuallySendOffersEnabled: companySettings.manually_send_offers,
      isMarineCvParsingEnabled: companySettings.marine_cv_parsing,
      isMasterJobApplicationsViewEnabled: companySettings.master_job_applications_view,
      isMaxApplicationsEnabled: companySettings.max_applications,
      isMergeAttachmentsToPdfEnabled: companySettings.merge_attachments_to_pdf,
      isMonitorSamlEnabled: companySettings.monitor_saml,
      isMonitorWithRumEnabled: companySettings.monitor_with_rum,
      isMoveToAnyJobEnabled: companySettings.move_to_any_job,
      isMoveToHiredOnOfferAcceptanceEnabled: companySettings.move_to_hired_on_offer_acceptance,
      isMultipleCompanyThemesEnabled: companySettings.multiple_company_themes,
      isMultipleJobPostingsEnabled: companySettings.multiple_job_postings,
      isMultipleQuestionCollectionsEnabled: companySettings.multiple_question_collections,
      isMultipleVideoInterviewProviderSupportEnabled: companySettings.multiple_video_interview_provider_support,
      isNewConferencingProviderUxEnabled: companySettings.new_conferencing_provider_ux,
      isNewCustomFieldReportingFiltersEnabled: companySettings.new_custom_field_reporting_filters,
      isNewWorkflowAutomationPricingEnabled: companySettings.new_workflow_automation_pricing,
      isNoReplyEmailsEnabled: companySettings.no_reply_emails,
      isNotifyInterestedCandidatesEnabled: companySettings.notify_interested_candidates,
      isOfferManagementEnabled: companySettings.offer_management,
      isOfferPacksEnabled: companySettings.offer_packs,
      isOfferRetractedNotificationEnabled: companySettings.offer_retracted_notification,
      isOfferSplittingEnabled: companySettings.offer_splitting,
      isOnboardingCandidateViewerRoleEnabled: companySettings.onboarding_candidate_viewer_role,
      isOnboardingDashboardStageStepOwnershipEnabled: companySettings.onboarding_dashboard_stage_step_ownership,
      isOnboardingDocumentTemplatesEnabled: companySettings.onboarding_document_templates,
      isOnboardingNotifyCandidateOnTeamMemberStageCompletionEnabled: companySettings.onboarding_notify_candidate_on_team_member_stage_completion,
      isOnboardingProcessStepDeadlockHandlersEnabled: companySettings.onboarding_process_step_deadlock_handlers,
      isOnboardingV1Enabled: companySettings.onboarding_v1,
      isOnboardingV2Enabled: companySettings.onboarding_v2,
      isOnboardingV2AssignedStepNotificationsEnabled: companySettings.onboarding_v2_assigned_step_notifications,
      isOnboardingV2BackgroundCheckNeedReviewOptOutEnabled: companySettings.onboarding_v2_background_check_need_review_opt_out,
      isOnboardingV2EnforceJobVisibilitiesEnabled: companySettings.onboarding_v2_enforce_job_visibilities,
      isOnboardingV2NotificationCandidateMessagesEnabled: companySettings.onboarding_v2_notification_candidate_messages,
      isOnboardingV2ProgressTrackerUpdatesEnabled: companySettings.onboarding_v2_progress_tracker_updates,
      isOnboardingV2ReportingEnabled: companySettings.onboarding_v2_reporting,
      isOnboardingV2StartDateChangeReasonsEnabled: companySettings.onboarding_v2_start_date_change_reasons,
      isOnboardingV2TurbochargerEnabled: companySettings.onboarding_v2_turbocharger,
      isOverridingJobAccessEnabled: companySettings.overriding_job_access,
      isPersonalDetailsAutoUpdateEnabled: companySettings.personal_details_auto_update,
      isPinpointChecksPausedEnabled: companySettings.pinpoint_checks_paused,
      isPositionManagementEnabled: companySettings.position_management,
      isPostmarkEventMonitoringEnabled: companySettings.postmark_event_monitoring,
      isPremiumWorkflowAutomationsEnabled: companySettings.premium_workflow_automations,
      isPrivateCalendarEventsEnabled: companySettings.private_calendar_events,
      isRadiusSearchEnabled: companySettings.radius_search,
      isReactSelectOnExternalJobsEnabled: companySettings.react_select_on_external_jobs,
      isRecruitmentAgenciesEnabled: companySettings.recruitment_agencies,
      isRecruitmentAgencyLocationMatchingEnabled: companySettings.recruitment_agency_location_matching,
      isRedirectMovedJobToCopiedObjectEnabled: companySettings.redirect_moved_job_to_copied_object,
      isRedirectToCopiedObjectEnabled: companySettings.redirect_to_copied_object,
      isRedirectToCustomSubdomainEnabled: companySettings.redirect_to_custom_subdomain,
      isReferenceCheckingEnabled: companySettings.reference_checking,
      isReferenceCheckingPausedEnabled: companySettings.reference_checking_paused,
      isReferenceCheckingReviewFormsEnabled: companySettings.reference_checking_review_forms,
      isReferenceCheckingTimeBasedEnabled: companySettings.reference_checking_time_based,
      isReferralManagementEnabled: companySettings.referral_management,
      isReferralsUserNotificationDefaultsEnabled: companySettings.referrals_user_notification_defaults,
      isRefreshCsrfTokenBeforeApplicationSubmitEnabled: companySettings.refresh_csrf_token_before_application_submit,
      isRejectAllOtherApplicationsEnabled: companySettings.reject_all_other_applications,
      isRemoveCompTimeUnitOnOfferEnabled: companySettings.remove_comp_time_unit_on_offer,
      isRemoveEmailFooterEnabled: companySettings.remove_email_footer,
      isRemoveLogoFromEmailTemplateEnabled: companySettings.remove_logo_from_email_template,
      isReportEmptyNotEmptyOperatorsEnabled: companySettings.report_empty_not_empty_operators,
      isReportOnlyCspEnabled: companySettings.report_only_csp,
      isRequireHeadcountEnabled: companySettings.require_headcount,
      isRestrictJobVisibilityEnabled: companySettings.restrict_job_visibility,
      isRestrictedCronofyOauthScopeEnabled: companySettings.restricted_cronofy_oauth_scope,
      isSavedViewsOpenStagesEnabled: companySettings.saved_views_open_stages,
      isScorecardSummaryEnabled: companySettings.scorecard_summary,
      isSemiPrivateCommentsEnabled: companySettings.semi_private_comments,
      isSendDailyRemindersForOnboardingStagesEnabled: companySettings.send_daily_reminders_for_onboarding_stages,
      isSendPdfCopyOfApplicationEnabled: companySettings.send_pdf_copy_of_application,
      isSendRescheduledInterviewCancellationEventsEnabled: companySettings.send_rescheduled_interview_cancellation_events,
      isShowAllCandidatesIndexEnabled: companySettings.show_all_candidates_index,
      isShowApiKeysOnceEnabled: companySettings.show_api_keys_once,
      isShowCompensationByDefaultEnabled: companySettings.show_compensation_by_default,
      isShowDateInOfferHeaderEnabled: companySettings.show_date_in_offer_header,
      isShowJobSeekersInAllCandidatesEnabled: companySettings.show_job_seekers_in_all_candidates,
      isShowPinpointCreditsMessagingEnabled: companySettings.show_pinpoint_credits_messaging,
      isSignOffSpecificityV2Enabled: companySettings.sign_off_specificity_v2,
      isSkillsEnabled: companySettings.skills,
      isStageDatesInExternalApplicationEnabled: companySettings.stage_dates_in_external_application,
      isStageGroupVisibilitiesEnabled: companySettings.stage_group_visibilities,
      isStageVisibilitiesEnabled: companySettings.stage_visibilities,
      isStateFiltersEnabled: companySettings.state_filters,
      isStrictOfccpComplianceEnabled: companySettings.strict_ofccp_compliance,
      isStructuredSectionsEnabled: companySettings.structured_sections,
      isTalentPipelineEnabled: companySettings.talent_pipeline,
      isTalentPipelineV2Enabled: companySettings.talent_pipeline_v2,
      isTaskManagementEnabled: companySettings.task_management,
      isTeamRejectionNotificationEnabled: companySettings.team_rejection_notification,
      isUpdatedRequisitionsCardsEnabled: companySettings.updated_requisitions_cards,
      isUpsellReferenceCheckingEnabled: companySettings.upsell_reference_checking,
      isUseChunkedReportFilteringEnabled: companySettings.use_chunked_report_filtering,
      isUseCompanyFromAddressEnabled: companySettings.use_company_from_address,
      isUseFallbackSignOffWorkflowsEnabled: companySettings.use_fallback_sign_off_workflows,
      isUsePlanetscaleOptimizedCandidateQueriesEnabled: companySettings.use_planetscale_optimized_candidate_queries,
      isUseReportDateIndexesEnabled: companySettings.use_report_date_indexes,
      isVariableSignOffSignatoriesEnabled: companySettings.variable_sign_off_signatories,
      isVideoInterviewWilloPausedEnabled: companySettings.video_interview_willo_paused,
      isVisibleOtherApplicationsEnabled: companySettings.visible_other_applications,
      isVonqV2Enabled: companySettings.vonq_v2,
      isWaypointLoggingEnabled: companySettings.waypoint_logging,
      isWhitelabelledBackgroundChecksMspEnabled: companySettings.whitelabelled_background_checks_msp,
      isWhitelabelledBackgroundChecksMspUatEnabled: companySettings.whitelabelled_background_checks_msp_uat,
      isWhitelabelledCertnCentricBackgroundChecksEnabled: companySettings.whitelabelled_certn_centric_background_checks,
      isWilloPinpointVideoInterviewingEnabled: companySettings.willo_pinpoint_video_interviewing,
      isWismCachedOnboardingApplicationEnabled: companySettings.wism_cached_onboarding_application,
      isWismMetricsTrackingEnabled: companySettings.wism_metrics_tracking,
      isWorkflowAutomationEnabled: companySettings.workflow_automation,
      isWorkflowAutomationV2Enabled: companySettings.workflow_automation_v2,
      isYoutubeCookieManagementEnabled: companySettings.youtube_cookie_management,
      isZincPollingProcessOnboardingAnswersEnabled: companySettings.zinc_polling_process_onboarding_answers,
    }),
    [companySettings],
  );
};

interface ICompanySettingProviderProps {
  companySettings: ICompanySettings;
}

export function CompanySettingProvider({
  companySettings,
  children,
}: React.PropsWithChildren<ICompanySettingProviderProps>) {
  return (
    <CompanySettingsContext.Provider
      value={{
        ...companySettingsInitialValues,
        ...companySettings,
      }}
    >
      {children}
    </CompanySettingsContext.Provider>
  );
}
